
document.addEventListener('DOMContentLoaded', () => {
  const $ = (s,c=document) => c.querySelector(s);
  const $$ = (s,c=document) => [...c.querySelectorAll(s)];

  const overlay = $('[data-overlay]');
  const menu = $('[data-menu]');
  const panels = $$('.mh-panel');

  function setOverlay(show){
    if(!overlay) return;
    overlay.hidden = !show;
  }
  function closeAll(){
    menu?.classList.remove('is-open');
    menu?.setAttribute('aria-hidden','true');
    panels.forEach(p=>{p.classList.remove('is-open');p.setAttribute('aria-hidden','true')});
    setOverlay(false);
  }
  function openPanel(sel){
    closeAll();
    const p=$(sel);
    if(p){p.classList.add('is-open');p.setAttribute('aria-hidden','false');setOverlay(true)}
  }

  document.addEventListener('click', async (e) => {
    if(e.target.closest('[data-menu-toggle]')){
      closeAll(); menu?.classList.add('is-open'); menu?.setAttribute('aria-hidden','false'); setOverlay(true);
    }
    if(e.target.closest('[data-menu-close]') || e.target.closest('[data-panel-close]') || e.target === overlay){
      closeAll();
    }
    if(e.target.closest('[data-search-toggle]')){
      openPanel('[data-search-panel]');
      setTimeout(()=> $('[data-search-input]')?.focus(), 50);
    }
    if(e.target.closest('[data-cart-toggle]')){
      openPanel('[data-cart-panel]'); await refreshCart();
    }
    if(e.target.closest('[data-favorites-toggle]')){
      renderFavorites(); openPanel('[data-favorites-panel]');
    }
  });

  // HERO
  const slides = $$('[data-hero-slide]');
  const dots = $$('[data-hero-dot]');
  let heroIndex = 0;
  const heroCount = () => slides.length;

  function showHero(n){
    if(!slides.length) return;
    heroIndex = (n + heroCount()) % heroCount();
    slides.forEach((s,i)=>s.classList.toggle('is-active',i===heroIndex));
    dots.forEach((d,i)=>d.classList.toggle('is-active',i===heroIndex));
  }
  dots.forEach(d=>d.addEventListener('click',()=>showHero(Number(d.dataset.heroDot))));
  window.addEventListener('resize',()=>{ if(heroIndex>=heroCount()) showHero(0); });
  let touchX = null;
  const hero = $('.mh-hero');
  hero?.addEventListener('touchstart',e=>{touchX=e.touches[0].clientX},{passive:true});
  hero?.addEventListener('touchend',e=>{
    if(touchX===null) return;
    const dx=e.changedTouches[0].clientX-touchX;
    if(Math.abs(dx)>45) showHero(heroIndex + (dx<0?1:-1));
    touchX=null;
  },{passive:true});
  // CATEGORY TABS: true horizontal carousel of covers, products below
  function openCategory(key){
    const tab=document.querySelector(`[data-category="${key}"]`);
    const display=document.getElementById('mh-category-display');
    const template=document.querySelector(`#mh-category-sources template[data-category-source="${key}"]`);
    if(!tab || !display || !template) return;

    document.querySelectorAll('.mh-category-tab').forEach(t=>{
      t.classList.toggle('is-active', t===tab);
    });

    display.innerHTML=template.innerHTML;
    display.hidden=false;

    if(window.mhSetupVariantPickers){
      window.mhSetupVariantPickers(display);
    }
    if(typeof syncFavoriteButtons==='function') syncFavoriteButtons();

    setTimeout(()=>display.scrollIntoView({behavior:'smooth',block:'nearest'}),120);
  }
  window.mhOpenCategory=openCategory;
  const requestedCategory=new URLSearchParams(window.location.search).get('categoria');
  if(requestedCategory) openCategory(requestedCategory);

  document.addEventListener('click',e=>{
    const opener=e.target.closest('[data-category-open]');
    if(opener){
      e.preventDefault();
      openCategory(opener.dataset.categoryOpen);
    }

    const back=e.target.closest('[data-category-back]');
    if(back){
      const display=document.getElementById('mh-category-display');
      if(display){
        display.hidden=true;
        display.innerHTML='';
      }
      document.querySelectorAll('.mh-category-tab').forEach(t=>t.classList.remove('is-active'));
      document.getElementById('categorias')?.scrollIntoView({behavior:'smooth',block:'nearest'});
    }
  });

  // FAVORITES
  const favKey='mihmosa-favorites-v1';
  const getFavs=()=>{try{return JSON.parse(localStorage.getItem(favKey)||'[]')}catch{return[]}};
  const setFavs=f=>localStorage.setItem(favKey,JSON.stringify(f));
  const favoriteProducts=new Map();
  let favoritesRender=0;

  function favoriteHandle(item){
    if(item.handle && /^[a-z0-9-]+$/i.test(item.handle)) return item.handle;
    try{
      const url=new URL(item.url,location.origin);
      if(url.origin!==location.origin) return '';
      return decodeURIComponent(url.pathname.match(/^\/products\/([^/]+)/)?.[1]||'');
    }catch{return ''}
  }

  function favoriteProduct(handle){
    if(!favoriteProducts.has(handle)){
      const request=fetch('/products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}})
        .then(r=>{if(!r.ok) throw new Error('Produto indisponível');return r.json()});
      favoriteProducts.set(handle,request);
      request.catch(()=>favoriteProducts.delete(handle));
    }
    return favoriteProducts.get(handle);
  }

  function syncFavoriteButtons(){
    const favs=getFavs();
    $$('[data-product-card],[data-v171-card]').forEach(card=>{
      const title=(card.dataset.title||'').trim();
      $('.mh-heart',card)?.classList.toggle('is-fav',favs.some(x=>x.title===title));
    });
    $$('[data-fav-count]').forEach(x=>x.textContent=favs.length);
  }
  async function renderFavorites(){
    const body=$('[data-favorites-body]');
    if(!body) return;
    const renderId=++favoritesRender;
    const favs=getFavs();
    const bulk=$('[data-favorites-add-all]');
    const status=$('[data-favorites-status]');
    if(bulk) bulk.disabled=true;
    if(status) status.textContent=favs.length?'Carregando opções dos produtos…':'';
    body.replaceChildren();
    if(!favs.length) body.textContent='Você ainda não favoritou produtos.';
    const rows=favs.map(item=>{
      const row=document.createElement('div');
      row.className='mh-fav-item';
      row.dataset.favTitle=item.title;
      if(item.image && /^(https?:\/\/|\/)/i.test(item.image)){
        const img=document.createElement('img');img.src=item.image;img.alt='';row.append(img);
      }
      const content=document.createElement('div');content.className='mh-fav-item-content';
      const link=document.createElement('a');
      const handle=favoriteHandle(item);
      link.href=handle?'/products/'+encodeURIComponent(handle):'#';
      link.textContent=item.title;
      content.append(link);
      const options=document.createElement('div');
      options.className='mh-fav-variant';
      options.textContent=handle?'Carregando opções…':'Produto sem vínculo com o carrinho.';
      content.append(options);
      const remove=document.createElement('button');
      remove.type='button';remove.className='mh-btn';remove.dataset.removeFav=encodeURIComponent(item.title);remove.textContent='Remover';
      content.append(remove);row.append(content);body.append(row);
      return {row,options,handle,item};
    });
    await Promise.all(rows.map(async ({row,options,handle,item})=>{
      if(!handle || !/^[a-z0-9-]+$/i.test(handle)) return;
      try{
        const product=await favoriteProduct(handle);
        if(renderId!==favoritesRender) return;
        const variants=(product.variants||[]).filter(v=>v.available && v.id);
        options.replaceChildren();
        if(!variants.length){options.textContent='Indisponível no momento.';return}
        const select=document.createElement('select');
        select.setAttribute('aria-label','Escolha a opção de '+item.title);
        variants.forEach(v=>{
          const option=document.createElement('option');
          option.value=String(v.id);
          option.textContent=(v.title && !/^(Default Title|Título padrão)$/i.test(v.title))?v.title:'Produto padrão';
          select.append(option);
        });
        if(variants.some(v=>String(v.id)===String(item.variantId))) select.value=String(item.variantId);
        options.append(select);
        options.classList.add('has-select');
        row.dataset.favReady='1';
      }catch{
        if(renderId===favoritesRender) options.textContent='Não foi possível carregar este produto.';
      }
    }));
    if(renderId===favoritesRender){
      const count=rows.filter(({row})=>row.dataset.favReady==='1').length;
      if(bulk) bulk.disabled=!count;
      if(status) status.textContent=count<favs.length
        ? `${count} de ${favs.length} favoritos disponíveis para adicionar.`
        : (count?'Escolha as opções e adicione todos ao carrinho.':'');
    }
    syncFavoriteButtons();
  }

  document.addEventListener('click',e=>{
    const btn=e.target.closest('[data-favorite]');
    if(btn){
      const card=btn.closest('[data-product-card],[data-v171-card]');
      if(!card) return;
      const title=(card.dataset.title||'').trim();
      const handle=(card.dataset.handle||'').trim();
      const image=card.dataset.image||card.querySelector('[data-v171-data]')?.dataset.productImage||card.querySelector('img')?.src||'';
      const url=card.dataset.url||(handle?('/products/'+encodeURIComponent(handle)):'#');
      const item={title,url,image,handle};
      let favs=getFavs();
      const idx=favs.findIndex(x=>x.title===item.title);
      if(idx>=0) favs.splice(idx,1); else favs.push(item);
      setFavs(favs); syncFavoriteButtons();
    }
    const rem=e.target.closest('[data-remove-fav]');
    if(rem){
      const title=decodeURIComponent(rem.dataset.removeFav);
      setFavs(getFavs().filter(x=>x.title!==title));
      renderFavorites();
    }
  });
  document.addEventListener('change',e=>{
    const select=e.target.closest('.mh-fav-item select');
    if(!select) return;
    const title=select.closest('.mh-fav-item')?.dataset.favTitle;
    const favs=getFavs();
    const item=favs.find(x=>x.title===title);
    if(item){item.variantId=select.value;setFavs(favs)}
  });

  document.addEventListener('click',async e=>{
    const button=e.target.closest('[data-favorites-add-all]');
    if(!button || button.disabled) return;
    button.disabled=true;
    const status=$('[data-favorites-status]');
    const rows=$$('.mh-fav-item',$('[data-favorites-body]'));
    let added=0;
    const failures=[];
    for(const row of rows){
      const select=row.querySelector('select');
      if(!select){failures.push(row.dataset.favTitle);continue}
      if(status) status.textContent=`Adicionando ${added+1} de ${rows.length}…`;
      try{
        const response=await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:Number(select.value),quantity:1})
        });
        if(!response.ok) throw new Error('Não foi possível adicionar');
        added++;
      }catch{failures.push(row.dataset.favTitle)}
    }
    button.disabled=false;
    if(added){openPanel('[data-cart-panel]');await refreshCart()}
    if(failures.length){
      const message=`${added} produto(s) adicionados. Não foi possível adicionar: ${failures.join(', ')}.`;
      if(status) status.textContent=message;
      alert(message);
    }else if(status) status.textContent=`${added} produto(s) adicionados ao carrinho.`;
  });
  syncFavoriteButtons();

  // SEARCH V146 — busca local mais fácil, tolerante e com variantes/referências
  const searchInput=$('[data-search-input]');
  const searchBox=$('[data-search-suggestions]');
  const searchForm=$('.mh-search-form');

  const normalizeSearch=(value='')=>String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g,'')
    .toLocaleLowerCase('pt-BR')
    .replace(/[’']/g,'')
    .replace(/[^a-z0-9]+/g,' ')
    .replace(/\s+/g,' ')
    .trim();

  const searchAliases={
    'vibro':'vibrador vibracao vibratorio vibrante pompoar',
    'vibrador':'vibro vibracao vibratorio',
    'plug':'plugs anal',
    'plugs':'plug anal',
    'gel':'geis lubrificante beijavel comestivel termico',
    'geis':'gel lubrificante beijavel comestivel termico',
    'jogo':'jogos baralho dados brincadeira brincadeiras',
    'jogos':'jogo baralho dados brincadeira brincadeiras',
    'autocuidado':'poesie blendy higiene hidratante body splash esfoliante sabonete desodorante',
    'cosmetico':'cosmeticos autocuidado gel poesie blendy',
    'cosmeticos':'cosmetico autocuidado gel poesie blendy',
    'prazer':'descobertas vibro plug pompoar capas',
    'capas':'capa expansora dedo maximizador',
    'capa':'capas expansora dedo maximizador'
  };

  function enrichQuery(query){
    const base=normalizeSearch(query);
    if(!base) return [];
    return base.split(' ').filter(Boolean).map(token=>
      [token,...(searchAliases[token] ? normalizeSearch(searchAliases[token]).split(' ') : [])]
    );
  }

  function getDetailSearchText(root, productId){
    if(!productId || !root) return '';
    const detail=root.querySelector?.(`[data-product-detail="${productId}"],#${productId}`);
    if(!detail) return '';
    const variants=[...detail.querySelectorAll('[data-full-variant],[data-variant-choice],[data-yummy-flavor]')]
      .map(el=>[
        el.dataset.fullVariant||'',
        el.dataset.variantChoice||'',
        el.dataset.yummyFlavor||'',
        el.dataset.variantModel||'',
        el.dataset.variantRef||'',
        el.textContent||''
      ].join(' '))
      .join(' ');
    return `${detail.textContent||''} ${variants}`;
  }

  function collectSearchItems(){
    const items=[];
    const seen=new Set();

    const push=(item)=>{
      if(!item.title) return;
      const key=(item.type+'|'+item.title+'|'+(item.product||'')).toLowerCase();
      if(seen.has(key)) return;
      seen.add(key);

      const haystack=[
        item.title,
        item.categoryLabel||'',
        item.extra||'',
        item.price||'',
        item.product||''
      ].join(' ');

      item.searchText=normalizeSearch(haystack);
      items.push(item);
    };

    // Categories
    $$('.mh-category-tab').forEach(tab=>{
      const category=tab.dataset.category||'';
      const title=tab.querySelector('.mh-category-label')?.textContent?.trim()||'';
      const image=tab.querySelector('img')?.src||'';
      push({
        type:'category',
        title,
        image,
        category,
        categoryLabel:title,
        price:'',
        extra:`${category} categoria`
      });
    });

    // Products rendered directly on the page
    $$('[data-product-card]').forEach(card=>{
      const opener=card.querySelector('[data-product-open]');
      const product=opener?.dataset.productOpen||'';
      const title=(card.dataset.title||'').trim();
      const cardText=card.textContent||'';
      push({
        type:'product',
        title,
        image:card.dataset.image||card.querySelector('img')?.src||'',
        price:card.querySelector('.mh-price')?.textContent?.trim()||'',
        product,
        yummy:!!card.querySelector('[data-yummy-view]'),
        category:'',
        extra:`${cardText} ${getDetailSearchText(document,product)}`
      });
    });

    // Current v171 products inside category templates
    $$('#mh-category-sources template[data-category-source]').forEach(t=>{
      const category=t.dataset.categorySource||'';
      const categoryLabel=document.querySelector(`[data-category="${category}"] .mh-category-label`)?.textContent?.trim()||category;
      t.content.querySelectorAll('[data-v171-card]').forEach(card=>{
        const title=(card.dataset.title||'').trim();
        const handle=(card.dataset.handle||'').trim();
        const image=card.querySelector('[data-v171-data]')?.dataset.productImage||card.querySelector('img')?.src||'';
        const price=card.querySelector('.mh-v171-copy>b')?.textContent?.trim()||'';
        const variants=[...card.querySelectorAll('[data-v171-variant]')].map(v=>[v.dataset.title||'',v.dataset.sku||''].join(' ')).join(' ');
        push({
          type:'product',
          title,
          image,
          price,
          product:handle,
          yummy:false,
          category,
          categoryLabel,
          extra:`${card.textContent||''} ${variants}`
        });
      });
    });

    // Products inside category templates
    $$('#mh-category-sources template[data-category-source]').forEach(t=>{
      const category=t.dataset.categorySource||'';
      const categoryLabel=document.querySelector(`[data-category="${category}"] .mh-category-label`)?.textContent?.trim()||category;

      t.content.querySelectorAll('[data-product-card]').forEach(card=>{
        const opener=card.querySelector('[data-product-open]');
        const product=opener?.dataset.productOpen||'';
        const title=(card.dataset.title||'').trim();
        const cardText=card.textContent||'';
        push({
          type:'product',
          title,
          image:card.dataset.image||card.querySelector('img')?.src||'',
          price:card.querySelector('.mh-price')?.textContent?.trim()||'',
          product,
          yummy:!!card.querySelector('[data-yummy-view]'),
          category,
          categoryLabel,
          extra:`${cardText} ${getDetailSearchText(t.content,product)}`
        });
      });
    });

    return items;
  }

  function scoreSearchItem(item,tokens,query){
    if(!tokens.length) return 0;
    const title=normalizeSearch(item.title);
    const category=normalizeSearch(item.categoryLabel||'');
    const text=item.searchText||'';

    let score=0;
    for(const alternatives of tokens){
      const token=alternatives[0];
      if(title===token) score+=120;
      else if(title.startsWith(token)) score+=80;
      else if(title.includes(token)) score+=55;
      else if(category.includes(token)) score+=26;
      else if(text.includes(token)) score+=16;
      else if(alternatives.slice(1).some(alias=>text.includes(alias))) score+=8;
      else return 0;
    }

    const q=normalizeSearch(query);
    if(q && title.includes(q)) score+=90;
    if(q && text.includes(q)) score+=20;
    if(item.type==='product') score+=8;
    return score;
  }

  function renderPageSearch(query=''){
    if(!searchBox) return;

    const raw=query.trim();
    const tokens=enrichQuery(raw);

    if(!raw){
      searchBox.innerHTML=`
        <div class="mh-search-welcome">
          <strong>O que você quer encontrar?</strong>
          <small>Digite um nome, tipo de produto, referência ou use uma busca rápida acima.</small>
        </div>`;
      return;
    }

    const results=collectSearchItems()
      .map(item=>({item,score:scoreSearchItem(item,tokens,raw)}))
      .filter(x=>x.score>0)
      .sort((a,b)=>b.score-a.score || a.item.title.localeCompare(b.item.title,'pt-BR'))
      .slice(0,20)
      .map(x=>x.item);

    searchBox.innerHTML=results.length ? `
      <div class="mh-search-summary">${results.length} ${results.length===1?'resultado':'resultados'} encontrado${results.length===1?'':'s'}</div>
      ${results.map(p=>`
        <button type="button" class="mh-search-result" data-search-result
          data-search-type="${p.type}"
          data-search-category="${p.category||''}"
          data-search-product="${p.product||''}"
          data-search-yummy="${p.yummy?'1':''}">
          <img src="${p.image}" alt="">
          <span class="mh-search-result-copy">
            <strong>${p.title}</strong>
            <small>${p.type==='category'
              ? 'Abrir categoria'
              : `${p.categoryLabel ? p.categoryLabel+' • ' : ''}Ver produto`}</small>
          </span>
          ${p.price?`<span class="mh-mini-search-price">${p.price}</span>`:''}
        </button>`).join('')}
    ` : `
      <div class="mh-search-empty-state">
        <strong>Nenhum produto encontrado</strong>
        <small>Tente um termo mais simples, como “vibro”, “gel”, “plug”, “Poésie” ou uma referência.</small>
      </div>`;
  }

  searchInput?.addEventListener('input',()=>renderPageSearch(searchInput.value));

  searchForm?.addEventListener('submit',e=>{
    if(!document.getElementById('mh-category-sources')) return;
    e.preventDefault();
    renderPageSearch(searchInput?.value||'');
  });

  $$('[data-search-toggle]').forEach(btn=>btn.addEventListener('click',()=>{
    setTimeout(()=>{
      renderPageSearch(searchInput?.value||'');
      searchInput?.focus();
    },30);
  }));

  document.addEventListener('click',e=>{
    const quick=e.target.closest('[data-search-quick]');
    if(quick){
      const q=quick.dataset.searchQuick||'';
      if(searchInput){
        searchInput.value=q;
        if(document.getElementById('mh-category-sources')){
          renderPageSearch(q);
          searchInput.focus();
        }else{
          searchForm?.requestSubmit();
        }
      }
      return;
    }

    const result=e.target.closest('[data-search-result]');
    if(!result) return;

    const type=result.dataset.searchType;
    const category=result.dataset.searchCategory;
    const product=result.dataset.searchProduct;
    const yummy=result.dataset.searchYummy==='1';

    closeAll();

    if(type==='category' && category && window.mhOpenCategory){
      window.mhOpenCategory(category);
      return;
    }

    if(category && window.mhOpenCategory){
      window.mhOpenCategory(category);
      setTimeout(()=>{
        const display=document.getElementById('mh-category-display');
        if(yummy){
          const yummyBtn=display?.querySelector('[data-yummy-view]');
          yummyBtn?.click();
        }else if(product){
          const v171Card=display?.querySelector(`[data-v171-card][data-handle="${product}"]`);
          const v171Opener=v171Card?.querySelector('[data-v171-open]');
          const opener=v171Opener||display?.querySelector(`[data-product-open="${product}"]`);
          if(opener){
            opener.click();
            setTimeout(()=>opener.scrollIntoView({behavior:'smooth',block:'center'}),80);
          }
        }
      },120);
      return;
    }

    if(product){
      const v171Card=document.querySelector(`[data-v171-card][data-handle="${product}"]`);
      const direct=v171Card?.querySelector('[data-v171-open]')||document.querySelector(`[data-product-open="${product}"]`);
      if(direct){
        direct.click();
        setTimeout(()=>direct.scrollIntoView({behavior:'smooth',block:'center'}),80);
        return;
      }
    }

    document.getElementById('produtos')?.scrollIntoView({behavior:'smooth',block:'start'});
  });

  // Main menu category buttons
  document.addEventListener('click',e=>{
    const btn=e.target.closest('[data-open-cat]');
    if(!btn) return;
    const category=btn.dataset.openCat||'';
    if(btn.tagName==='A'&&!document.querySelector(`[data-category="${category}"]`)) return;
    e.preventDefault();
    closeAll();
    window.mhOpenCategory?.(category);
  });
  // CARRINHO DE CONSULTA PARA PRODUTOS ILUSTRATIVOS
  const demoCartKey='mihmosa-demo-cart-v1';
  const getDemoCart=()=>{try{return JSON.parse(localStorage.getItem(demoCartKey)||'[]')}catch{return[]}};
  const setDemoCart=items=>localStorage.setItem(demoCartKey,JSON.stringify(items));

  function addDemoItem(btn){
    const title=btn.dataset.demoTitle||'Produto';
    const price=btn.dataset.demoPrice||'';
    const image=btn.dataset.demoImage||'';
    const quantityNode=btn.closest('[data-product-detail], .mh-full-info')?.querySelector('[data-full-qty]');
    const quantity=Math.max(1,Number(quantityNode?.textContent)||1);
    const items=getDemoCart();
    const found=items.find(x=>x.title===title);
    if(found) found.quantity=(found.quantity||1)+quantity;
    else items.push({title,price,image,quantity});
    setDemoCart(items);
  }

  function renderDemoCart(){
    const items=getDemoCart();
    if(!items.length) return '';
    return `<div class="mh-demo-cart-title">Itens ilustrativos — confirme disponibilidade</div>`+
      items.map((i,index)=>`
        <div class="mh-cart-line">
          <div>
            <strong>${i.title}</strong>
            <small>${i.price} · ${i.quantity} un.</small>
            <div class="mh-cart-controls">
              <button type="button" class="mh-remove-icon" data-demo-remove="${index}" aria-label="Remover item" title="Remover item"><span aria-hidden="true">🗑</span></button>
              <a class="mh-btn" href="https://wa.me/5592985358950?text=${encodeURIComponent('Oi! Quero saber a disponibilidade do '+i.title)}">Consultar</a>
            </div>
          </div>
        </div>`).join('');
  }


  function brlToCents(value){
    if(!value) return 0;
    const cleaned=String(value)
      .replace(/\s/g,'')
      .replace('R$','')
      .replace(/\./g,'')
      .replace(',','.')
      .replace(/[^\d.-]/g,'');
    const number=Number(cleaned);
    return Number.isFinite(number) ? Math.round(number*100) : 0;
  }

  function demoCartTotalCents(){
    return getDemoCart().reduce((sum,item)=>{
      return sum + brlToCents(item.price) * Number(item.quantity || 1);
    },0);
  }

  // CART
  async function getCart(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json())}

  // Confere o carrinho real antes de abrir o checkout. O submit nativo para
  // /cart pode voltar à loja quando não há uma variante válida na sessão.
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.mh-cart-drawer-checkout, .mh-cart-page-form');
    if (!form) return;
    const submitter = e.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    e.preventDefault();
    if (form.dataset.checkoutPending === '1') return;
    form.dataset.checkoutPending = '1';
    submitter.disabled = true;
    try {
      if (form.classList.contains('mh-cart-page-form')) {
        const updates = [...form.querySelectorAll('input[name="updates[]"]')].map(input => Math.max(0, Number(input.value) || 0));
        const response = await fetch('/cart/update.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates})});
        if (!response.ok) throw new Error('Não foi possível atualizar o carrinho. Tente novamente.');
      }
      const cart = await getCart();
      if (!Number(cart.item_count || 0)) {
        await refreshCart();
        throw new Error('Seu carrinho da Shopify está vazio. Adicione um produto novamente antes de finalizar a compra.');
      }
      window.location.assign('/checkout');
    } catch (err) {
      alert(err.message || 'Não foi possível abrir o checkout. Tente novamente.');
      submitter.disabled = false;
      delete form.dataset.checkoutPending;
    }
  }, true);
  async function refreshCart(){
    try{
      const cart=await getCart();
      const demoItems=getDemoCart();
      const demoQty=demoItems.reduce((sum,i)=>sum+Number(i.quantity||1),0);
      $$('[data-cart-count]').forEach(x=>x.textContent=cart.item_count + demoQty);
      const combinedTotal=Number(cart.total_price||0)+demoCartTotalCents();
      if($('[data-cart-subtotal]')){
        $('[data-cart-subtotal]').textContent=(combinedTotal/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
      }
      const body=$('[data-cart-body]');
      if(!body) return;
      const demoHtml=renderDemoCart();
      if(!cart.items.length && !demoHtml){body.innerHTML='<p>Seu carrinho está vazio.</p>';return}
      const realHtml=cart.items.map((i,index)=>`
        <div class="mh-cart-line mh-cart-line-real">
          ${i.image ? `<a class="mh-cart-line-image" href="${i.url||'#'}"><img src="${i.image}" alt=""></a>` : ''}
          <div class="mh-cart-line-copy">
            <strong>${i.product_title}</strong>
            ${i.variant_title && !/Default Title|Título padrão/i.test(i.variant_title) ? `<small>${i.variant_title}</small>` : ''}
            <small>${(i.final_line_price/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}</small>
            <div class="mh-cart-controls">
              <button type="button" data-cart-change="${index+1}" data-qty="${Math.max(0,i.quantity-1)}" aria-label="Diminuir quantidade">−</button>
              <span>${i.quantity}</span>
              <button type="button" data-cart-change="${index+1}" data-qty="${i.quantity+1}" aria-label="Aumentar quantidade">+</button>
              <button type="button" class="mh-remove-icon" data-cart-change="${index+1}" data-qty="0" aria-label="Remover item" title="Remover item"><span aria-hidden="true">🗑</span></button>
            </div>
          </div>
        </div>`).join('');
      body.innerHTML=realHtml+demoHtml;
    }catch(err){}
  }

  document.addEventListener('click',async e=>{
    const add=e.target.closest('[data-add-cart]');
    if(add){
      add.disabled=true;
      try{
        const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(add.dataset.addCart),quantity:1})});
        if(!response.ok){let data={};try{data=await response.json()}catch{}throw new Error(data.description||data.message||'Não foi possível adicionar este item ao carrinho.');}
        openPanel('[data-cart-panel]'); await refreshCart();
      } catch(err) { alert(err.message||'Não foi possível adicionar este item ao carrinho.'); }
      finally {add.disabled=false}
    }
    const demoAdd=e.target.closest('[data-demo-add]');
    if(demoAdd){
      addDemoItem(demoAdd);
      openPanel('[data-cart-panel]');
      await refreshCart();
    }
    const demoRemove=e.target.closest('[data-demo-remove]');
    if(demoRemove){
      const items=getDemoCart();
      items.splice(Number(demoRemove.dataset.demoRemove),1);
      setDemoCart(items);
      await refreshCart();
    }

    const ch=e.target.closest('[data-cart-change]');
    if(ch){
      try {
        const response=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(ch.dataset.cartChange),quantity:Number(ch.dataset.qty)})});
        if(!response.ok) throw new Error('Não foi possível atualizar o carrinho. Tente novamente.');
        await refreshCart();
      } catch(err) { alert(err.message||'Não foi possível atualizar o carrinho. Tente novamente.'); }
    }
  });


  // FINALIZAR PEDIDO PELO WHATSAPP — RESUMO PREMIUM E LEGÍVEL
  function mhCleanWhatsAppText(value){
    const text=String(value??'').trim();
    if(!text || /^(undefined|null)$/i.test(text)) return '';
    return text.replace(/\s+/g,' ').trim();
  }

  function mhFormatBRLFromCents(cents){
    return (Number(cents||0)/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'}).replace(/\u00a0/g,' ');
  }

  function mhSplitDemoTitle(rawTitle){
    const raw=mhCleanWhatsAppText(rawTitle)||'Produto';
    const parts=raw.split(/\s+[—–]\s+/).map(mhCleanWhatsAppText).filter(Boolean);
    const product=parts.shift()||raw;
    let variant=parts.join(' · ');

    // Algumas variantes antigas usam " - Ref. 000". Converte para separador elegante.
    variant=variant
      .replace(/\s+-\s+(Ref\.\s*[^·]+)$/i,' · $1')
      .replace(/\s+—\s+/g,' · ')
      .replace(/\s*·\s*/g,' · ')
      .trim();

    return {product,variant};
  }

  function mhBuildOrderItemLines(product,variant,ref,quantity,lineTotalCents){
    const cleanProduct=mhCleanWhatsAppText(product)||'Produto';
    let cleanVariant=mhCleanWhatsAppText(variant);
    let cleanRef=mhCleanWhatsAppText(ref);
    const qty=Math.max(1,Number(quantity)||1);

    // Evita duplicar referência se ela já estiver escrita na variante.
    if(cleanVariant && /\bRef\.?\s*[:.#-]?\s*\w+/i.test(cleanVariant)) cleanRef='';
    if(cleanRef && !/^Ref\./i.test(cleanRef)) cleanRef='Ref. '+cleanRef;

    const details=[];
    if(cleanVariant && !/^(Default Title|Título padrão)$/i.test(cleanVariant)) details.push(cleanVariant);
    if(cleanRef) details.push(cleanRef);
    details.push(`${qty} un.`);

    return [
      `• *${cleanProduct}*`,
      details.join(' · '),
      `*${mhFormatBRLFromCents(lineTotalCents)}*`
    ];
  }

  async function buildWhatsAppOrderMessage(){
    let cart={items:[],total_price:0};
    try{ cart=await getCart(); }catch(e){}

    const demoItems=getDemoCart();
    const lines=[];
    lines.push('💗 *Olá! Vim pelo site da MIH’MOSA.*');
    lines.push('Gostaria de finalizar meu pedido:');
    lines.push('');
    lines.push('🛍️ *Meu carrinho*');

    let hasItems=false;

    if(cart.items && cart.items.length){
      cart.items.forEach(i=>{
        hasItems=true;
        lines.push('');
        const variant=mhCleanWhatsAppText(i.variant_title);
        const ref=mhCleanWhatsAppText(i.sku);
        lines.push(...mhBuildOrderItemLines(
          i.product_title,
          variant,
          ref,
          i.quantity,
          Number(i.final_line_price||0)
        ));
      });
    }

    if(demoItems.length){
      demoItems.forEach(i=>{
        hasItems=true;
        lines.push('');
        const parsed=mhSplitDemoTitle(i.title);
        const qty=Math.max(1,Number(i.quantity)||1);
        const subtotal=brlToCents(i.price)*qty;
        lines.push(...mhBuildOrderItemLines(parsed.product,parsed.variant,'',qty,subtotal));
      });
    }

    if(!hasItems){
      lines.push('');
      lines.push('• Carrinho vazio');
    }

    const combinedTotal=Number(cart.total_price||0)+demoCartTotalCents();
    if(combinedTotal>0){
      lines.push('');
      lines.push(`✨ *Total estimado: ${mhFormatBRLFromCents(combinedTotal)}*`);
    }

    lines.push('');
    lines.push('Poderia confirmar a disponibilidade dos itens e o valor da entrega, por favor? 💗');
    lines.push('');
    lines.push('_MIH’MOSA | Atendimento discreto_');

    return lines.join('\n');
  }

  async function openWhatsAppCheckout(){
    const message=await buildWhatsAppOrderMessage();
    window.location.href='https://wa.me/5592985358950?text='+encodeURIComponent(message);
  }

  document.addEventListener('click', async e=>{
    if(e.target.closest('[data-whatsapp-checkout]')){
      await openWhatsAppCheckout();
    }
  });


  // YUMMY — visualização interna expansível
  const yummyDetail=$('[data-yummy-detail]');
  const yummySlides=()=>$$('[data-yummy-slide]',yummyDetail||document);
  let yummyIndex=0;
  let yummyFlavor='Menta';
  let yummyQty=1;

  function updateYummyDots(){
    $$('[data-yummy-dot]',yummyDetail||document).forEach((d,i)=>d.classList.toggle('is-active',i===yummyIndex));
  }
  function showYummySlide(i){
    const slides=yummySlides();
    if(!slides.length) return;
    yummyIndex=(i+slides.length)%slides.length;
    slides.forEach((s,idx)=>s.classList.toggle('is-active',idx===yummyIndex));
    updateYummyDots();
  }
  function selectYummyFlavor(flavor){
    if(!yummyDetail) return;
    const btn=$$('[data-yummy-flavor]',yummyDetail).find(b=>b.dataset.yummyFlavor===flavor) || $('[data-yummy-flavor]',yummyDetail);
    if(!btn) return;
    yummyFlavor=btn.dataset.yummyFlavor;
    $$('[data-yummy-flavor]',yummyDetail).forEach(b=>b.classList.toggle('is-active',b===btn));
    const selected=$('[data-yummy-selected]',yummyDetail);
    if(selected) selected.textContent=yummyFlavor;
    const slides=yummySlides();
    if(slides[0]){slides[0].src=btn.dataset.img1;slides[0].alt='Yummy '+yummyFlavor}
    if(slides[1]){slides[1].src=btn.dataset.img2;slides[1].alt='Yummy '+yummyFlavor+' detalhe'}
    const add=$('[data-yummy-add]',yummyDetail);
    if(add){
      add.dataset.demoTitle='Yummy – Gel Térmico Beijável 15 ml — '+yummyFlavor;
      add.dataset.demoImage=btn.dataset.img1;
    }
    showYummySlide(0);
  }
  function setYummyQty(qty){
    yummyQty=Math.max(1,Math.min(20,Number(qty)||1));
    const q=$('[data-yummy-qty]',yummyDetail||document);
    if(q) q.textContent=yummyQty;
  }
  function openYummy(flavor){
    if(!yummyDetail) return;
    yummyDetail.hidden=false;
    setYummyQty(1);
    selectYummyFlavor(flavor||'Morango');
    setTimeout(()=>yummyDetail.scrollIntoView({behavior:'smooth',block:'nearest'}),30);
  }
  function closeYummy(){
    if(!yummyDetail) return;
    yummyDetail.hidden=true;
  }

  document.addEventListener('click', async e=>{
    const view=e.target.closest('[data-yummy-view]');
    if(view){openYummy(view.dataset.yummyView)}

    if(e.target.closest('[data-yummy-close]')) closeYummy();
    if(e.target.closest('[data-yummy-prev]')) showYummySlide(yummyIndex-1);
    if(e.target.closest('[data-yummy-next]')) showYummySlide(yummyIndex+1);

    const dot=e.target.closest('[data-yummy-dot]');
    if(dot) showYummySlide(Number(dot.dataset.yummyDot));

    const flavor=e.target.closest('[data-yummy-flavor]');
    if(flavor) selectYummyFlavor(flavor.dataset.yummyFlavor);

    if(e.target.closest('[data-yummy-minus]')) setYummyQty(yummyQty-1);
    if(e.target.closest('[data-yummy-plus]')) setYummyQty(yummyQty+1);

    const add=e.target.closest('[data-yummy-add]');
    if(add){
      const items=getDemoCart();
      const title=add.dataset.demoTitle;
      const found=items.find(x=>x.title===title);
      if(found) found.quantity=(found.quantity||1)+yummyQty;
      else items.push({title,price:'R$ 14,90',image:add.dataset.demoImage,quantity:yummyQty});
      setDemoCart(items);
      await refreshCart();
      openPanel('[data-cart-panel]');
    }
  });

  if(yummyDetail){
    let startX=null;
    const stage=$('.mh-yummy-stage',yummyDetail);
    stage?.addEventListener('touchstart',e=>{startX=e.touches[0].clientX},{passive:true});
    stage?.addEventListener('touchend',e=>{
      if(startX===null) return;
      const dx=e.changedTouches[0].clientX-startX;
      if(Math.abs(dx)>40) showYummySlide(yummyIndex+(dx<0?1:-1));
      startX=null;
    },{passive:true});
  }

  refreshCart();
});

/* moved from snippets/mihmosa-catalogo-assets.liquid */
document.addEventListener('click',function(e){var root=e.target.closest('[data-subcatalog]');if(!root)return;var open=e.target.closest('[data-sub-open]');if(open){root.querySelector('[data-subcovers]').hidden=true;root.querySelectorAll('[data-subpanel]').forEach(function(p){p.hidden=p.dataset.subpanel!==open.dataset.subOpen});root.querySelector('[data-subpanel="'+open.dataset.subOpen+'"]').scrollIntoView({behavior:'smooth',block:'nearest'})}var back=e.target.closest('[data-sub-back]');if(back){root.querySelectorAll('[data-subpanel]').forEach(function(p){p.hidden=true});root.querySelector('[data-subcovers]').hidden=false;root.scrollIntoView({behavior:'smooth',block:'nearest'})}var prev=e.target.closest('[data-strip-prev]'),next=e.target.closest('[data-strip-next]');if(prev||next){var track=e.target.closest('[data-product-strip]').querySelector('[data-product-track]');track.scrollBy({left:(next?1:-1)*Math.min(track.clientWidth*.85,300),behavior:'smooth'})}var view=e.target.closest('[data-product-open]');if(view){var panel=view.closest('[data-subpanel]');panel.querySelectorAll('[data-product-detail]').forEach(function(d){d.hidden=d.dataset.productDetail!==view.dataset.productOpen});var opened=panel.querySelector('[data-product-detail="'+view.dataset.productOpen+'"]');if(opened){opened.scrollIntoView({behavior:'smooth',block:'center'});var firstBtn=opened.querySelector('[data-full-variant].is-active')||opened.querySelector('[data-full-variant]');if(firstBtn)requestAnimationFrame(function(){firstBtn.click()});}}var close=e.target.closest('[data-product-close]');if(close)close.closest('[data-product-detail]').hidden=true;var minus=e.target.closest('[data-full-minus]'),plus=e.target.closest('[data-full-plus]');if(minus||plus){var detail=e.target.closest('[data-product-detail]'),q=detail.querySelector('[data-full-qty]'),n=Number(q.textContent)||1;q.textContent=Math.max(1,n+(plus?1:-1))}});
function mhShowProductGallery(gallery,index){var slides=[].slice.call(gallery.querySelectorAll('[data-gallery-slide]'));var dots=[].slice.call(gallery.querySelectorAll('[data-gallery-dot]'));if(!slides.length)return;index=(index+slides.length)%slides.length;gallery.dataset.galleryIndex=index;slides.forEach(function(slide,i){slide.hidden=i!==index});dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===index)})}
document.addEventListener('click',function(e){var gallery=e.target.closest('[data-product-gallery]');var opener=e.target.closest('[data-product-open]');if(opener){var detail=opener.closest('[data-subpanel]').querySelector('[data-product-detail="'+opener.dataset.productOpen+'"]');var initial=detail&&detail.querySelector('[data-product-gallery]');if(initial){var isAccessory=!!opener.closest('.mh-subcatalog--acessorios');mhShowProductGallery(initial,isAccessory?1:0)}}if(!gallery)return;var index=Number(gallery.dataset.galleryIndex)||0;if(e.target.closest('[data-gallery-prev]'))mhShowProductGallery(gallery,index-1);if(e.target.closest('[data-gallery-next]'))mhShowProductGallery(gallery,index+1);var dot=e.target.closest('[data-gallery-dot]');if(dot)mhShowProductGallery(gallery,Number(dot.dataset.galleryDot))});
document.addEventListener('touchstart',function(e){var gallery=e.target.closest('[data-product-gallery]');if(gallery)gallery.dataset.touchX=e.touches[0].clientX},{passive:true});
document.addEventListener('touchend',function(e){var gallery=e.target.closest('[data-product-gallery]');if(!gallery||!gallery.dataset.touchX)return;var dx=e.changedTouches[0].clientX-Number(gallery.dataset.touchX);if(Math.abs(dx)>42)mhShowProductGallery(gallery,(Number(gallery.dataset.galleryIndex)||0)+(dx<0?1:-1));delete gallery.dataset.touchX},{passive:true});

window.mhSetupVariantPickers=function(root){root.querySelectorAll('[data-product-detail]').forEach(function(detail){if(detail.dataset.variantReady)return;var copy=detail.querySelector('.mh-detail-copy');if(!copy)return;var info=[].slice.call(copy.children).find(function(el){return el.tagName==='SPAN' && /Versões e referências:/i.test(el.textContent)});if(!info)return;var raw=info.textContent.split(':').slice(1).join(':').trim();var refs=raw.split(',').map(function(x){return x.trim()}).filter(Boolean);if(refs.length<=1)return;detail.dataset.variantReady='1';var block=document.createElement('div');block.className='mh-variant-picker';block.innerHTML='<span>Opções do mesmo produto</span><div class="mh-variant-buttons"></div>';var holder=block.querySelector('.mh-variant-buttons');var add=detail.querySelector('[data-demo-add]');var title=(copy.querySelector('h4')||{}).textContent||'Produto';refs.forEach(function(ref,i){var b=document.createElement('button');b.type='button';b.textContent=ref;b.dataset.fullVariant=ref;if(i===0)b.classList.add('is-active');holder.appendChild(b)});var qty=copy.querySelector('.mh-yummy-qty');copy.insertBefore(block, qty || add || null);if(add){add.dataset.baseTitle=title;add.dataset.demoTitle=title+' — '+refs[0]}}) }
document.addEventListener('click',function(e){var btn=e.target.closest('[data-full-variant]');if(!btn)return;var wrap=btn.closest('.mh-variant-buttons');wrap.querySelectorAll('button').forEach(function(b){b.classList.toggle('is-active',b===btn)});var detail=btn.closest('[data-product-detail]');var add=detail&&detail.querySelector('[data-demo-add]');if(add){var base=add.dataset.baseTitle || ((detail.querySelector('h4')||{}).textContent||'Produto');add.dataset.baseTitle=base;add.dataset.demoTitle=base+' — '+btn.dataset.fullVariant;}});
document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('[data-subcatalog], .mh-panel-flat').forEach(function(root){mhSetupVariantPickers(root)})});

/* V47 fixes: current-category product open, gallery, and variant viewing */
(function(){
  function mhCurrentScope(el){
    return el.closest('.mh-category-display') || document.getElementById('mh-category-display') || document;
  }
  function mhShowGallerySafe(gallery,index){
    var slides=[].slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var dots=[].slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
    if(!slides.length) return;
    index=(index+slides.length)%slides.length;
    gallery.dataset.galleryIndex=index;
    slides.forEach(function(slide,i){ slide.hidden = i!==index; });
    dots.forEach(function(dot,i){ dot.classList.toggle('is-active', i===index); });
  }
  document.addEventListener('click', function(e){
    var openBtn=e.target.closest('[data-product-open]');
    if(openBtn){
      var scope=mhCurrentScope(openBtn);
      var details=scope.querySelectorAll('[data-product-detail]');
      details.forEach(function(d){ d.hidden = d.dataset.productDetail !== openBtn.dataset.productOpen; });
      var detail=scope.querySelector('[data-product-detail="'+openBtn.dataset.productOpen+'"]');
      if(detail){
        detail.hidden=false;
        if(window.mhSetupVariantPickers) window.mhSetupVariantPickers(detail.parentElement || scope);
        var gallery=detail.querySelector('[data-product-gallery]');
        if(gallery) mhShowGallerySafe(gallery,0);
        setTimeout(function(){ detail.scrollIntoView({behavior:'smooth', block:'center'}); }, 30);
      }
    }
    var closeBtn=e.target.closest('[data-product-close]');
    if(closeBtn){
      var detail = closeBtn.closest('[data-product-detail]');
      if(detail) detail.hidden = true;
    }
    var minus=e.target.closest('[data-full-minus]'), plus=e.target.closest('[data-full-plus]');
    if(minus || plus){
      var detail2=(minus||plus).closest('[data-product-detail]');
      if(detail2){
        var q=detail2.querySelector('[data-full-qty]');
        var n=Number(q && q.textContent) || 1;
        if(q) q.textContent = Math.max(1, n + (plus ? 1 : -1));
      }
    }
    var prev=e.target.closest('[data-gallery-prev]'), next=e.target.closest('[data-gallery-next]'), dot=e.target.closest('[data-gallery-dot]');
    if(prev || next || dot){
      var gallery2=(prev||next||dot).closest('[data-product-gallery]');
      if(gallery2){
        var idx=Number(gallery2.dataset.galleryIndex) || 0;
        if(prev) mhShowGallerySafe(gallery2, idx-1);
        if(next) mhShowGallerySafe(gallery2, idx+1);
        if(dot) mhShowGallerySafe(gallery2, Number(dot.dataset.galleryDot));
      }
    }
  });
  document.addEventListener('touchstart', function(e){ var g=e.target.closest('[data-product-gallery]'); if(g) g.dataset.touchX=e.touches[0].clientX; }, {passive:true});
  document.addEventListener('touchend', function(e){ var g=e.target.closest('[data-product-gallery]'); if(!g||!g.dataset.touchX) return; var dx=e.changedTouches[0].clientX-Number(g.dataset.touchX); if(Math.abs(dx)>42){ mhShowGallerySafe(g,(Number(g.dataset.galleryIndex)||0)+(dx<0?1:-1)); } delete g.dataset.touchX; }, {passive:true});
})();

/* Navegação flutuante dos carrosséis da página inicial. Mantém o gesto de arrastar. */
(function(){
  const selector='.mh-category-zone > .mh-tabs, #produtos .mh-inline-carousel, #mh-category-display .mh-v171-track';

  function install(track){
    if(track.dataset.mhFloatReady==='1') return;
    track.dataset.mhFloatReady='1';
    const wrap=document.createElement('div');
    wrap.className='mh-float-wrap';
    track.parentNode.insertBefore(wrap,track);
    wrap.appendChild(track);

    const arrows=[-1,1].map(direction=>{
      const button=document.createElement('button');
      button.type='button';
      button.className='mh-float-arrow '+(direction<0?'mh-float-arrow--prev':'mh-float-arrow--next');
      button.setAttribute('aria-label',direction<0?'Ver itens anteriores':'Ver próximos itens');
      button.innerHTML=direction<0?'&#8249;':'&#8250;';
      button.addEventListener('click',()=>{
        const items=[...track.children].filter(el=>el.getClientRects().length);
        const current=track.scrollLeft;
        const positions=items.map(el=>el.offsetLeft-items[0].offsetLeft);
        const target=direction>0
          ? positions.find(pos=>pos>current+3)
          : positions.filter(pos=>pos<current-3).pop();
        if(target!==undefined) track.scrollTo({left:target,behavior:'smooth'});
      });
      wrap.appendChild(button);
      return button;
    });

    let pending=false;
    const update=()=>{
      pending=false;
      const max=Math.max(0,track.scrollWidth-track.clientWidth);
      arrows[0].hidden=max<8 || track.scrollLeft<4;
      arrows[1].hidden=max<8 || track.scrollLeft>=max-4;
    };
    const schedule=()=>{
      if(pending)return;
      pending=true;
      requestAnimationFrame(update);
    };
    track.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    if('ResizeObserver' in window) new ResizeObserver(schedule).observe(track);
    update();
  }

  function installAll(root=document){
    root.querySelectorAll(selector).forEach(install);
  }
  function start(){
    installAll();
    const display=document.getElementById('mh-category-display');
    if(display) new MutationObserver(()=>installAll(display)).observe(display,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();

(function(){
  function applyCatalogVariant(button){
    const detail=button.closest('[data-product-detail]');
    if(!detail)return;
    detail.querySelectorAll('[data-catalog-variant-picker] [data-full-variant]').forEach(function(option){
      option.classList.toggle('is-active',option===button);
      option.setAttribute('aria-pressed',option===button?'true':'false');
    });
    const label=button.dataset.fullVariant||button.textContent.trim();
    const image=button.dataset.variantImage||'';
    const price=button.dataset.variantPrice||'';
    const selected=detail.querySelector('[data-variant-selected]');
    if(selected)selected.textContent='Selecionado: '+label;

    const capBox=detail.querySelector('[data-cap-selected]');
    if(capBox){
      const model=button.dataset.variantModel||label.replace(/\s*-\s*Ref\.\s*\d+\s*$/i,'').trim();
      const ref=button.dataset.variantRef||'';
      const modelEl=capBox.querySelector('[data-cap-model]');
      const refEl=capBox.querySelector('[data-cap-ref]');
      const priceEl=capBox.querySelector('[data-cap-price]');
      if(modelEl)modelEl.textContent=model;
      if(refEl)refEl.textContent=ref;
      if(priceEl&&price)priceEl.textContent=price;
    }
    const gallery=detail.querySelector('[data-product-gallery]');
    if(gallery&&image){
      const slides=gallery.querySelectorAll('[data-gallery-slide]');
      const pid=detail.dataset.productDetail||'';
      if(pid==='p80'||pid==='p81'){
        // Plugs: preserve the supplied session gallery and replace only the main photo
        // with the image tied to the selected reference/model.
        if(slides[0]){
          slides[0].src=image;
          slides[0].alt=label;
          slides[0].hidden=false;
        }
        slides.forEach(function(slide,index){if(index!==0)slide.hidden=true;});
      }else{
        slides.forEach(function(slide,index){slide.src=image;slide.alt=label;slide.hidden=index!==0;});
      }
      gallery.dataset.galleryIndex='0';
      gallery.querySelectorAll('[data-gallery-dot]').forEach(function(dot,index){dot.classList.toggle('is-active',index===0);});
    }
    const visiblePrice=detail.querySelector('.mh-detail-copy > b');
    if(visiblePrice&&price)visiblePrice.textContent=price;
    const add=detail.querySelector('[data-demo-add]');
    if(add){
      const base=add.dataset.baseTitle||(detail.querySelector('h4')&&detail.querySelector('h4').textContent)||'Produto';
      add.dataset.baseTitle=base;
      add.dataset.demoTitle=base+' — '+label;
      if(price)add.dataset.demoPrice=price;
      if(image)add.dataset.demoImage=image;
      add.dataset.variantRef=button.dataset.variantRef||'';
    }
  }
  document.addEventListener('click',function(event){
    const button=event.target.closest('[data-catalog-variant-picker] [data-full-variant]');
    if(!button)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    applyCatalogVariant(button);
  },true);
  document.addEventListener('click',function(event){
    const opener=event.target.closest('[data-product-open]');
    if(!opener)return;
    requestAnimationFrame(function(){
      const detail=document.querySelector('[data-product-detail="'+opener.dataset.productOpen+'"]');
      const first=detail&&detail.querySelector('[data-catalog-variant-picker] [data-full-variant].is-active');
      if(first)applyCatalogVariant(first);
    });
  },true);
})();


/* V52 — dynamic UI fixes: named variations, working search/menu, arrows and Yummy */
(function(){
  const MH_VARIANTS={"p03":["Blueberry","Chiclete","Maçã do Amor","Pêssego"],"p04":["Gel 15g"],"p05":["Gel 15g","Cápsulas 3 un."],"p06":["Gel 15g","Pomada 7,5g","Cápsulas 3 un."],"p07":["Gel 15g","Cápsulas 3 un.","Sachê 5g"],"p08":["Gel 15g","Pomada 7,5g","Cápsulas 3 un."],"p09":["Gel 15g","Cápsulas 3 un."],"p10":["Gel 15g","Cápsulas 3 un."],"p11":["Gel 15g","Pomada 7,5g","Cápsulas 3 un."],"p12":["Gel 15g","Pomada 7,5g","Cápsulas 3 un."],"p13":["Gel 15g","Cápsulas 3 un."],"p14":["Gel 15g"],"p15":["Gel 15g","Pomada 7,5g","Cápsulas 3 un."],"p16":["Gel 15g"],"p17":["Gel 15g","Cápsulas 3 un."],"p18":["Gel 15g","Cápsulas 3 un.","Morango · Spray 15ml","Menta · Spray 15ml","Chiclete · Spray 15ml"],"p19":["Chiclete","Menta","Morango"],"p20":["Eletrizante","Esquenta e Esfria","Mix Intenso"],"p21":["Morango Ice","Mentho-Lyptus Extra Forte","Chiclete Ice"],"p22":["Eletrizante","Extra Ice","Extra Hot"],"p24":["Algodão Doce","Chiclete de Hortelã","Chiclete Intenso","Morango c/ Framboesa","Uva Verde"],"p25":["Morango · Hot","Chiclete · Hot","Morango c/ Chocolate · Hot","Cereja · Ice","Ice Menta · Ice","Caipirinha · Ice"],"p26":["Vodka c/ Melancia","Vinho Tinto","Caipirinha"],"p28":["Ácido Hialurônico · 60g"],"p29":["Maçã Verde","Abacaxi","Chiclete de Hortelã"],"p33":["Atrevida","Audaciosa","Selvagem"],"p34":["Morango","Chiclete","Ice Menta"],"p35":["Chiclete","Morango"],"p36":["Morango","Menta","Chiclete"],"p37":["Morango","Chiclete","Chocolate"],"p38":["Provoque","Seduza","Instigue","Envolva","Cative"],"p39":["Chiclete","Chiclete de Uva","Morango c/ Chantilly"],"p40":["Morango","Erva-doce","Menta","Chiclete","Bala de Goma","Chiclete de Hortelã"],"p41":["Morango","Chiclete"],"p42":["Bala de Goma","Chiclete","Morango"],"p43":["Bala de Goma","Chiclete","Morango"],"p46":["Feminino","Masculino"],"p48":["Masculino · Touro","Feminino · Vaca","Unissex · Energético","Masculino · Jegue","Feminino · Égua","Unissex · Energético Maçã Verde"],"p49":["Caramelo Salgado","Chocolate"],"p50":["Foguinho · Morango","Enfermeira · Morango","Diabinha · Morango","Policial · Ice Menta"],"p51":["Morango","Chocolate","Chiclete"],"p52":["Morango","Chocolate","Menta"],"p53":["11,7 × 3,1 cm","14,5 × 3,7 cm","15,3 × 4 cm · modelo 1","15,3 × 4 cm · modelo 2","15,3 × 4 cm · modelo 3","15,3 × 4 cm · modelo 4","15,3 × 4,5 cm","16,5 × 3,8 cm","17,5 × 4,4 cm","18,5 × 4,2 cm · modelo 1","18,5 × 4,2 cm · modelo 2","18,5 × 4,2 cm · modelo 3","19 × 4,9 cm","21 × 5,8 cm"],"p54":["Morango","Chiclete","Chocolate"],"p55":["14 × 3,7 cm","15,3 × 4 cm · modelo 1","15,3 × 4 cm · modelo 2","15,3 × 4 cm · modelo 3","15,3 × 4,5 cm","17,4 × 4,1 cm","18 × 4,5 cm · modelo 1","18 × 4,5 cm · modelo 2","18 × 4,5 cm · modelo 3","18 × 4,4 cm","22 × 5,8 cm"],"p58":["13 cm","13 cm · textura 2","16 cm","16 cm · textura 2","13 cm · modelo 3","13 cm · modelo 4","11 cm","13 cm · modelo 5","13 cm · modelo 6","16 cm · modelo 3"],"p59":["Pedra Cristal","Pedra Dourada","Pedra Vermelha","Pedra Roxa","Pedra Rosa","Cravejado","Cravejado Premium","Pedra Rosa Premium","Pedra Cristal 2","Pedra Dourada 2","Pedra Vermelha 2","Pedra Roxa 2","Pedra Rosa 2","Pingente","Pedra Roxa Premium","Cravejado 2","Cravejado 3"],"p60":["Pedra Cristal","Pedra Dourada","Pedra Vermelha","Pedra Roxa","Pedra Rosa","Dedal","Com Algemas","Rabo Normal","Rabo Pompom","Rabo Longo","6 Esferas","6 Esferas · modelo 2","6 Esferas · modelo 3","6 Esferas · modelo 4","6 Esferas · modelo 5","7,5 × 1,5 cm"]};

  function setupNamedVariants(root){
    (root||document).querySelectorAll('[data-product-detail]').forEach(function(detail){
      // V53: do not rebuild an already-prepared picker. Rebuilding it inside a
      // MutationObserver loop was causing the category panel to freeze on tap.
      if(detail.dataset.variantReady==='named') return;
      const pid=detail.dataset.productDetail;
      const labels=MH_VARIANTS[pid]||[];
      const copy=detail.querySelector('.mh-detail-copy');
      if(!copy) return;
      /* V88: se o produto já tem seletor real no HTML, preserve-o. */
      const existingPicker = copy.querySelector('.mh-variant-picker');
      if(existingPicker){
        detail.dataset.variantReady = existingPicker.querySelector('[data-full-variant][data-variant-image]') ? 'named' : 'real';
        return;
      }
      const info=[].slice.call(copy.children).find(function(el){return el.tagName==='SPAN' && /Versões e referências:/i.test(el.textContent)});
      if(info) info.hidden=true;
      if(!labels.length) return;
      const block=document.createElement('div');
      block.className='mh-variant-picker mh-variant-picker--pills';
      const label=document.createElement('span');
      label.className='mh-variant-title';
      label.textContent=labels.length>1?'Escolha a variação':'Variação';
      const holder=document.createElement('div');
      holder.className='mh-variant-buttons';
      labels.forEach(function(name,i){
        const b=document.createElement('button');
        b.type='button';
        b.textContent=name;
        b.setAttribute('data-full-variant',name);
        if(i===0)b.classList.add('is-active');
        holder.appendChild(b);
      });
      block.appendChild(label);block.appendChild(holder);
      const qty=copy.querySelector('.mh-yummy-qty');
      const add=copy.querySelector('[data-demo-add]');
      copy.insertBefore(block,qty||add||null);
      if(add){
        const title=(copy.querySelector('h4')||{}).textContent||'Produto';
        add.dataset.baseTitle=title;
        add.dataset.demoTitle=title+' — '+labels[0];
      }
      detail.dataset.variantReady='named';
    });
  }
  window.mhSetupVariantPickers=setupNamedVariants;

  document.addEventListener('click',function(e){
    const btn=e.target.closest('[data-full-variant]');
    if(!btn) return;
    const detail=btn.closest('[data-product-detail]');
    if(!detail) return;
    detail.querySelectorAll('[data-full-variant]').forEach(function(b){b.classList.toggle('is-active',b===btn)});
    const add=detail.querySelector('[data-demo-add]');
    if(add){
      const base=add.dataset.baseTitle||detail.querySelector('h4')?.textContent||'Produto';
      add.dataset.demoTitle=base+' — '+btn.dataset.fullVariant;
    }
  });

  // Make carousel arrows work everywhere, including dynamically injected category panels.
  document.addEventListener('click',function(e){
    const prev=e.target.closest('[data-strip-prev]');
    const next=e.target.closest('[data-strip-next]');
    if(!prev&&!next) return;
    const strip=(prev||next).closest('[data-product-strip]');
    const track=strip&&strip.querySelector('[data-product-track]');
    if(track) track.scrollBy({left:(next?1:-1)*Math.min(track.clientWidth*.86,340),behavior:'smooth'});
  });

  function yummyDetailFrom(el){
    const scope=el?.closest('#mh-category-display')||document.getElementById('mh-category-display')||document;
    return scope.querySelector('[data-yummy-detail]');
  }
  function yummySetFlavor(detail,btn){
    if(!detail||!btn)return;
    detail.querySelectorAll('[data-yummy-flavor]').forEach(function(b){b.classList.toggle('is-active',b===btn)});
    const flavor=btn.dataset.yummyFlavor;
    const selected=detail.querySelector('[data-yummy-selected]'); if(selected)selected.textContent=flavor;
    const slides=detail.querySelectorAll('[data-yummy-slide]');
    if(slides[0]){slides[0].src=btn.dataset.img1;slides[0].hidden=false;slides[0].classList.add('is-active')}
    if(slides[1]){slides[1].src=btn.dataset.img2;slides[1].hidden=true;slides[1].classList.remove('is-active')}
    detail.dataset.yummyIndex='0';
    detail.querySelectorAll('[data-yummy-dot]').forEach(function(d,i){d.classList.toggle('is-active',i===0)});
    const add=detail.querySelector('[data-yummy-add-only]');
    if(add){add.dataset.demoTitle='Yummy – Gel Térmico Beijável 15 ml — '+flavor;add.dataset.demoImage=btn.dataset.img1}
  }
  function yummyShow(detail,index){
    const slides=[].slice.call(detail.querySelectorAll('[data-yummy-slide]')); if(!slides.length)return;
    index=(index+slides.length)%slides.length; detail.dataset.yummyIndex=String(index);
    slides.forEach(function(s,i){s.hidden=i!==index;s.classList.toggle('is-active',i===index)});
    detail.querySelectorAll('[data-yummy-dot]').forEach(function(d,i){d.classList.toggle('is-active',i===index)});
  }
  document.addEventListener('click',async function(e){
    const view=e.target.closest('[data-yummy-view]');
    if(view){
      const detail=yummyDetailFrom(view); if(detail){detail.hidden=false;const flavor=detail.querySelector('[data-yummy-flavor="'+(view.dataset.yummyView||'Morango')+'"]')||detail.querySelector('[data-yummy-flavor]');yummySetFlavor(detail,flavor);const q=detail.querySelector('[data-yummy-qty]');if(q)q.textContent='1';setTimeout(function(){detail.scrollIntoView({behavior:'smooth',block:'center'})},30)}
    }
    const detail=yummyDetailFrom(e.target);
    if(!detail)return;
    if(e.target.closest('[data-yummy-close]')) detail.hidden=true;
    const flav=e.target.closest('[data-yummy-flavor]'); if(flav)yummySetFlavor(detail,flav);
    const prev=e.target.closest('[data-yummy-prev]'),next=e.target.closest('[data-yummy-next]');
    if(prev||next) yummyShow(detail,(Number(detail.dataset.yummyIndex)||0)+(next?1:-1));
    const dot=e.target.closest('[data-yummy-dot]'); if(dot)yummyShow(detail,Number(dot.dataset.yummyDot)||0);
    const minus=e.target.closest('[data-yummy-minus]'),plus=e.target.closest('[data-yummy-plus]');
    if(minus||plus){const q=detail.querySelector('[data-yummy-qty]');let n=Number(q?.textContent)||1;n=Math.max(1,Math.min(20,n+(plus?1:-1)));if(q)q.textContent=String(n)}
    const add=e.target.closest('[data-yummy-add-only]');
    if(add){
      const q=Number(detail.querySelector('[data-yummy-qty]')?.textContent)||1;
      const key='mihmosa-demo-cart-v1'; let items=[]; try{items=JSON.parse(localStorage.getItem(key)||'[]')}catch(_){}
      const title=add.dataset.demoTitle||'Yummy – Gel Térmico Beijável 15 ml';
      const found=items.find(function(x){return x.title===title});
      if(found)found.quantity=(found.quantity||1)+q;else items.push({title:title,price:'R$ 14,90',image:add.dataset.demoImage||'',quantity:q});
      localStorage.setItem(key,JSON.stringify(items));
      document.querySelector('[data-cart-toggle]')?.click();
    }
  });

  // V53: category injection already calls window.mhSetupVariantPickers(display)
  // from openCategory(). No MutationObserver is needed here; keeping one caused
  // self-triggering DOM mutations and could lock the page after opening a category.
  setupNamedVariants(document);
})();


/* V58 — close marcado por variação, sem posições aleatórias */
(function(){
  /*
    Os pontos abaixo são marcados na própria arte de cada produto.
    Formato: "nome da variação": [x%, y%, zoom].
    Quando não houver ponto nominal, usamos uma linha central previsível
    (nunca uma grade aleatória) para manter o close no conjunto de produtos.
  */
  const MH_VARIANT_FOCUS={
    p03:{"Blueberry":[20,52,2.2],"Chiclete":[40,50,2.2],"Maçã do Amor":[60,50,2.2],"Pêssego":[80,52,2.2]},
    p05:{"Gel 15g":[35,50,2.0],"Cápsulas 3 un.":[70,52,2.0]},
    p06:{"Gel 15g":[28,48,2.0],"Pomada 7,5g":[54,54,2.05],"Cápsulas 3 un.":[77,50,2.0]},
    p07:{"Gel 15g":[30,49,2.0],"Cápsulas 3 un.":[68,50,2.0],"Sachê 5g":[84,58,2.0]},
    p08:{"Gel 15g":[28,48,2.0],"Pomada 7,5g":[53,54,2.0],"Cápsulas 3 un.":[77,50,2.0]},
    p09:{"Gel 15g":[34,48,2.0],"Cápsulas 3 un.":[69,53,2.0]},
    p10:{"Gel 15g":[34,48,2.0],"Cápsulas 3 un.":[69,52,2.0]},
    p11:{"Gel 15g":[28,48,2.0],"Pomada 7,5g":[53,55,2.0],"Cápsulas 3 un.":[78,50,2.0]},
    p12:{"Gel 15g":[28,48,2.0],"Pomada 7,5g":[53,55,2.0],"Cápsulas 3 un.":[78,50,2.0]},
    p13:{"Gel 15g":[34,49,2.0],"Cápsulas 3 un.":[69,52,2.0]},
    p15:{"Gel 15g":[28,48,2.0],"Pomada 7,5g":[53,55,2.0],"Cápsulas 3 un.":[78,50,2.0]},
    p17:{"Gel 15g":[34,49,2.0],"Cápsulas 3 un.":[69,52,2.0]},
    p18:{"Gel 15g":[18,51,2.1],"Cápsulas 3 un.":[34,52,2.1],"Menta Spray 15ml":[53,48,2.1],"Chiclete Spray 15ml":[69,48,2.1],"Morango Spray 15ml":[84,48,2.1]},
    p19:{"Chiclete":[26,51,2.08],"Menta":[50,51,2.08],"Morango":[75,51,2.08]},
    p20:{"Eletrizante":[24,52,2.05],"Esquenta e Esfria":[50,52,2.05],"Mix Intenso":[76,52,2.05]},
    p21:{"Morango Ice":[27,52,2.05],"Mentho-Lyptus":[50,52,2.05],"Chiclete Ice":[75,52,2.05]},
    p22:{"Eletrizante":[27,52,2.05],"Extra Ice":[50,52,2.05],"Extra Hot":[75,52,2.05]},
    p24:{"Algodão Doce":[17,51,2.18],"Chiclete de Hortelã":[34,50,2.18],"Chiclete Intenso":[50,50,2.18],"Morango c/ Framboesa":[67,50,2.18],"Uva Verde":[83,50,2.18]},
    p25:{"Morango c/ Chocolate":[16,52,2.18],"Hot":[30,52,2.18],"Hot Morango c/ Chocolate":[44,52,2.18],"Cereja Ice":[58,52,2.18],"Ice Menta":[72,52,2.18],"Caipirinha Ice":[86,52,2.18]},
    p26:{"Vodka c/ Melancia":[22,52,2.08],"Vinho Tinto":[50,55,2.08],"Caipirinha":[78,52,2.08]},
    p29:{"Maçã Verde":[27,52,2.04],"Abacaxi":[50,52,2.04],"Chiclete de Hortelã":[75,52,2.04]},
    p33:{"Atrevida":[28,52,2.0],"Audaciosa":[50,52,2.0],"Selvagem":[73,52,2.0]},
    p34:{"Morango":[26,52,2.03],"Chiclete":[50,52,2.03],"Ice Menta":[75,52,2.03]},
    p35:{"Chiclete":[35,52,1.95],"Morango":[66,52,1.95]},
    p37:{"Morango":[26,52,2.03],"Chiclete":[50,52,2.03],"Chocolate":[75,52,2.03]},
    p38:{"Provoque":[16,52,2.18],"Seduza":[33,52,2.18],"Instigue":[50,52,2.18],"Envolva":[67,52,2.18],"Cative":[84,52,2.18]},
    p58:{"13 cm":[20,24,2.45],"13 cm — textura 2":[50,23,2.45],"16 cm":[79,24,2.45],"16 cm — textura 2":[20,40,2.35],"13 cm — modelo 3":[50,40,2.35],"13 cm — modelo 4":[79,40,2.35],"11 cm":[20,57,2.35],"13 cm — modelo 5":[50,57,2.35],"13 cm — modelo 6":[79,57,2.35],"16 cm — modelo 3":[21,75,2.45]},
    p59:{"Pedra Cristal":[20,22,2.4],"Pedra Dourada":[50,22,2.4],"Pedra Vermelha":[80,22,2.4],"Pedra Roxa":[20,39,2.4],"Pedra Rosa":[50,39,2.4],"Cravejado":[80,39,2.4],"Cravejado Premium":[20,56,2.4],"Pedra Rosa Premium":[50,56,2.4],"Pedra Cristal 2":[80,56,2.4],"Pedra Dourada 2":[20,73,2.4],"Pedra Vermelha 2":[50,73,2.4],"Pedra Roxa 2":[80,73,2.4],"Pedra Rosa 2":[20,56,2.4],"Pingente":[50,56,2.4],"Pedra Roxa Premium":[80,56,2.4],"Cravejado 2":[20,73,2.4],"Cravejado 3":[50,73,2.4]},
    p60:{"Pedra Cristal":[19,22,2.4],"Pedra Dourada":[50,22,2.4],"Pedra Vermelha":[81,22,2.4],"Pedra Roxa":[19,40,2.4],"Pedra Rosa":[50,40,2.4],"Dedal":[81,40,2.4],"Com Algemas":[19,58,2.4],"Rabo Normal":[50,58,2.4],"Rabo Pompom":[81,58,2.4],"Rabo Longo":[19,75,2.4],"6 Esferas":[50,75,2.4],"6 Esferas — modelo 2":[81,75,2.4],"6 Esferas — modelo 3":[19,58,2.4],"6 Esferas — modelo 4":[50,58,2.4],"6 Esferas — modelo 5":[81,58,2.4],"7,5 x 1,5 cm":[50,75,2.4]}
  };

  function fallbackFocus(index,total){
    const n=Math.max(1,total), min=20, max=80;
    const x=n===1?50:min+(max-min)*(index/Math.max(1,n-1));
    return [x,52,n<=3?1.95:n<=5?2.08:2.18];
  }

  function applyMarkedClose(detail,btn){
    if(!detail||!btn) return;
    const gallery=detail.querySelector('[data-product-gallery]');
    if(!gallery) return;
    const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
    if(!slides.length) return;
    const buttons=[...detail.querySelectorAll('[data-full-variant]')];
    const index=Math.max(0,buttons.indexOf(btn));
    const pid=detail.dataset.productDetail||'';
    const name=btn.dataset.fullVariant||btn.textContent.trim();
    const point=(MH_VARIANT_FOCUS[pid]&&MH_VARIANT_FOCUS[pid][name]) || fallbackFocus(index,buttons.length);

    // Sempre usa a foto-base do produto aberto; o que muda é apenas o recorte marcado.
    const target=slides[0];
    slides.forEach((img,i)=>{
      img.hidden=i!==0;
      img.classList.remove('is-variant-close');
      img.style.removeProperty('--mh-focus-x');
      img.style.removeProperty('--mh-focus-y');
      img.style.removeProperty('--mh-focus-scale');
    });
    target.hidden=false;
    target.classList.add('is-variant-close');
    target.style.setProperty('--mh-focus-x',point[0]+'%');
    target.style.setProperty('--mh-focus-y',point[1]+'%');
    target.style.setProperty('--mh-focus-scale',String(point[2]||2.1));
    gallery.dataset.galleryIndex='0';
    gallery.querySelectorAll('[data-gallery-dot]').forEach((dot,i)=>dot.classList.toggle('is-active',i===0));
  }

  document.addEventListener('click',function(e){
    const btn=e.target.closest('[data-full-variant]');
    if(!btn) return;
    const detail=btn.closest('[data-product-detail]');
    requestAnimationFrame(()=>applyMarkedClose(detail,btn));
  });
})();



/* V59 — LED tátil + indicadores de carrossel */
(function(){
  const interactiveSelector='button:not(.mh-remove-icon),a,[data-product-card],.mh-category-cover,.mh-catalog-card,.mh-subcover,[role="button"]';
  let active=null;
  function light(el){
    if(active&&active!==el) active.classList.remove('mh-led-active');
    active=el;
    if(active&&!active.classList.contains('mh-remove-icon')) active.classList.add('mh-led-active');
  }
  function clear(){ if(active){const el=active; setTimeout(()=>el.classList.remove('mh-led-active'),180); active=null;} }
  document.addEventListener('pointerdown',e=>light(e.target.closest(interactiveSelector)));
  document.addEventListener('pointerup',clear);
  document.addEventListener('pointercancel',clear);
  document.addEventListener('touchmove',e=>{
    const t=e.touches&&e.touches[0]; if(!t)return;
    const el=document.elementFromPoint(t.clientX,t.clientY)?.closest(interactiveSelector);
    if(el) light(el);
  },{passive:true});
  document.addEventListener('touchend',clear,{passive:true});

  function initDots(root){
    (root||document).querySelectorAll('.mh-tabs,.mh-inline-carousel,.mh-product-track,.mh-subcovers').forEach(track=>{
      if(track.dataset.mhDotsReady==='1') return;
      const kids=[...track.children].filter(el=>el.offsetParent!==null || !document.body.contains(el));
      if(kids.length<2 || track.scrollWidth<=track.clientWidth+8) return;
      track.dataset.mhDotsReady='1';
      const count=Math.min(kids.length,8);
      const nav=document.createElement('div'); nav.className='mh-carousel-indicators'; nav.setAttribute('aria-label','Indicador do carrossel');
      for(let i=0;i<count;i++){
        const b=document.createElement('button'); b.type='button'; b.className='mh-carousel-dot'+(i===0?' is-active':''); b.setAttribute('aria-label','Ir para posição '+(i+1));
        b.addEventListener('click',()=>{const max=Math.max(0,track.scrollWidth-track.clientWidth); track.scrollTo({left:count===1?0:max*i/(count-1),behavior:'smooth'});});
        nav.appendChild(b);
      }
      track.insertAdjacentElement('afterend',nav);
      const update=()=>{
        const max=Math.max(1,track.scrollWidth-track.clientWidth); const idx=Math.max(0,Math.min(count-1,Math.round((track.scrollLeft/max)*(count-1))));
        nav.querySelectorAll('.mh-carousel-dot').forEach((d,i)=>d.classList.toggle('is-active',i===idx));
      };
      track.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update,{passive:true});
      update();
    });
  }
  window.mhInitCarouselDots=initDots;
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initDots(document)); else initDots(document);
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-category-open],[data-product-open],[data-category-back]')) setTimeout(()=>initDots(document.getElementById('mh-category-display')||document),80);
  });
})();


/* V63 — limpeza de UI dinâmica */
(function(){
  function cleanMihmosaUI(root){
    root = root || document;

    /* remove botão duplicado de voltar; preserva o botão principal estilizado */
    var backs = Array.prototype.slice.call(
      root.querySelectorAll('a,button')
    ).filter(function(el){
      return (el.textContent || '').trim().replace(/\s+/g,' ')
        .match(/^(←\s*)?Voltar às categorias$/i);
    });
    if (backs.length > 1) {
      var keep = backs.find(function(el){
        return el.classList.contains('mh-back-btn') ||
               el.closest('.mh-category-head') ||
               getComputedStyle(el).backgroundColor !== 'rgb(255, 255, 255)';
      }) || backs[0];
      backs.forEach(function(el){ if(el !== keep) el.remove(); });
    }

    /* esconde setas dentro da visualização de produto; swipe continua */
    root.querySelectorAll(
      '.mh-yummy-detail [data-gallery-prev],.mh-yummy-detail [data-gallery-next],'+
      '.mh-product-detail [data-gallery-prev],.mh-product-detail [data-gallery-next],'+
      '[data-product-detail] [aria-label*="Anterior"],[data-product-detail] [aria-label*="Próximo"],'+
      '[data-product-detail] [aria-label*="anterior"],[data-product-detail] [aria-label*="próximo"]'
    ).forEach(function(el){ el.style.display='none'; });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ cleanMihmosaUI(document); });
  } else {
    cleanMihmosaUI(document);
  }

  /* Sem observer contínuo: limpa apenas depois dos cliques que abrem conteúdo dinâmico */
  document.addEventListener('click', function(){
    setTimeout(function(){ cleanMihmosaUI(document); }, 60);
  }, true);
})();


/* V65 — Novidades e favoritos com produtos reais da loja */
document.addEventListener('click', function(e){
  var btn = e.target.closest('[data-favorite-jump]');
  if(!btn) return;

  var category = btn.dataset.favoriteCategory;
  var product = btn.dataset.favoriteJump;
  var categoryBtn = document.querySelector('[data-category-open="'+category+'"]');
  if(!categoryBtn) return;

  categoryBtn.click();

  setTimeout(function(){
    var display = document.getElementById('mh-category-display');
    if(!display) return;

    var opener = display.querySelector('[data-product-open="'+product+'"]');
    if(opener){
      opener.click();
      setTimeout(function(){
        var detail = display.querySelector('[data-product-detail="'+product+'"]');
        if(detail) detail.scrollIntoView({behavior:'smooth', block:'center'});
      }, 80);
    }else{
      display.scrollIntoView({behavior:'smooth', block:'start'});
    }
  }, 100);
});


/* V66 — refinamentos defensivos */
(function(){
  function ensureCleanUI(){
    /* mantém apenas um botão de voltar visível por painel */
    document.querySelectorAll('[data-category-panel], .mh-category-panel').forEach(function(panel){
      var backs = Array.from(panel.querySelectorAll('[data-category-back], .mh-back-btn'))
        .filter(function(el){ return getComputedStyle(el).display !== 'none'; });
      if(backs.length > 1){
        backs.slice(1).forEach(function(el){ el.style.display='none'; });
      }
    });

    /* setas de galeria ficam desativadas; navegação continua por swipe/dots */
    document.querySelectorAll('.mh-gallery-arrow,.mh-strip-arrow,[data-gallery-prev],[data-gallery-next]')
      .forEach(function(el){ el.style.display='none'; });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', ensureCleanUI, {once:true});
  } else {
    ensureCleanUI();
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-category-open],[data-product-open],[data-favorite-jump]')){
      setTimeout(ensureCleanUI, 80);
    }
  }, true);
})();


/* V69 — legenda curta em todos os cards + consistência */
(function(){
  function addVariantHints(root){
    (root || document).querySelectorAll('[data-product-card]').forEach(function(card){
      if(card.querySelector('.mh-variant-hint')) return;

      var existingSmall = Array.from(card.querySelectorAll('small')).find(function(el){
        return /escolha|visualiza|sabor|varia/i.test(el.textContent || '');
      });
      if(existingSmall){
        existingSmall.classList.add('mh-variant-hint');
        return;
      }

      var hint = document.createElement('small');
      hint.className = 'mh-variant-hint';
      hint.textContent = 'Ao visualizar, escolha o sabor, aroma, tamanho ou variação disponível.';

      var actions = card.querySelector('.mh-card-actions');
      if(actions) card.insertBefore(hint, actions);
      else card.appendChild(hint);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ addVariantHints(document); }, {once:true});
  }else{
    addVariantHints(document);
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-category-open],[data-favorite-jump],[data-product-open]')){
      setTimeout(function(){ addVariantHints(document); }, 80);
    }
  }, true);
})();


/* V70 — variações reais por sabor/fragrância */
(function(){
  var hintMap = {
    'Yummy Gourmet':'Escolha o sabor ao visualizar o produto.',
    'Bolinha Hot':'Escolha o sabor e o efeito ao visualizar.',
    'D4 Textura Leitosa':'Escolha o sabor ao visualizar o produto.',
    'Felina':'Escolha a fragrância ao visualizar o produto.',
    'Um Beijo e Um Cheiro':'Escolha o sabor ao visualizar o produto.',
    'Perfume de Calcinha':'Escolha a fragrância ao visualizar.',
    'Fogo da Paixão':'Escolha o aroma ao visualizar o produto.',
    'Corpo a Corpo':'Escolha o sabor ao visualizar o produto.',
    'Excitantric':'Escolha a fragrância ao visualizar o produto.',
    'Poésie Desodorante Íntimo':'Escolha a fragrância ao visualizar.',
    'Poésie Body Splash':'Escolha a fragrância ao visualizar.',
    'Canetas Sweet Body':'Escolha o sabor ao visualizar o produto.'
  };

  function refineHints(root){
    (root || document).querySelectorAll('[data-product-card]').forEach(function(card){
      var title = (card.dataset.title || '').trim();
      var hint = card.querySelector('.mh-variant-hint');
      if(hint && hintMap[title]) hint.textContent = hintMap[title];
    });
  }

  function chooseVariant(btn){
    var detail = btn.closest('[data-product-detail]');
    if(!detail) return;

    detail.querySelectorAll('[data-variant-choice]').forEach(function(b){
      b.classList.toggle('is-active', b === btn);
    });

    var label = btn.dataset.variantLabel || btn.textContent.trim();
    var img = btn.dataset.variantImage;
    var selected = detail.querySelector('[data-variant-selected]');
    if(selected) selected.textContent = 'Selecionado: ' + label;

    if(img){
      var slides = detail.querySelectorAll('[data-gallery-slide]');
      slides.forEach(function(slide, i){
        slide.src = img;
        slide.alt = label;
        slide.hidden = i !== 0;
      });

      detail.querySelectorAll('[data-gallery-dot]').forEach(function(dot,i){
        dot.classList.toggle('is-active', i === 0);
      });

      var gallery = detail.querySelector('[data-product-gallery]');
      if(gallery) gallery.dataset.galleryIndex = '0';

      var add = detail.querySelector('[data-demo-add]');
      if(add){
        add.dataset.demoImage = img;
        var base = (detail.querySelector('h4') || {}).textContent || add.dataset.demoTitle || '';
        add.dataset.demoTitle = base + ' - ' + label;
      }
    }
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-variant-choice]');
    if(btn){
      e.preventDefault();
      chooseVariant(btn);
      return;
    }
    if(e.target.closest('[data-category-open],[data-product-open],[data-favorite-jump]')){
      setTimeout(function(){ refineHints(document); },80);
    }
  }, true);

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ refineHints(document); }, {once:true});
  }else{
    refineHints(document);
  }
})();


/* V80 — somente variações reais com imagem correspondente + limpeza dos legados */
(function(){
  const REAL_VARIANT_HINTS = {
    'Yummy Gourmet':'Escolha o sabor ao visualizar o produto.',
    'Bolinha Hot':'Escolha o sabor e o efeito ao visualizar.',
    'D4 Textura Leitosa':'Escolha o sabor ao visualizar o produto.',
    'Felina':'Escolha a fragrância ao visualizar o produto.',
    'Um Beijo e Um Cheiro':'Escolha o sabor ao visualizar o produto.',
    'Perfume de Calcinha':'Escolha a fragrância ao visualizar.',
    'Fogo da Paixão':'Escolha o aroma ao visualizar o produto.',
    'Corpo a Corpo':'Escolha o sabor ao visualizar o produto.',
    'Excitantric':'Escolha a fragrância ao visualizar o produto.',
    'Poésie Desodorante Íntimo':'Escolha a fragrância ao visualizar.',
    'Poésie Body Splash':'Escolha a fragrância ao visualizar.',
    'Canetas Sweet Body':'Escolha o sabor ao visualizar o produto.'
  };

  function detailForCard(card){
    const url = (card.dataset.url || '').replace(/^#/, '');
    if(!url) return null;
    return document.querySelector('[data-product-detail="'+url+'"]') || document.getElementById(url);
  }

  function hasRealVariantChoices(detail){
    return !!(detail && detail.querySelector('[data-variant-choice]'));
  }

  function removeLegacyVariantUI(root){
    /* V88: nenhum seletor de variação é removido.
       data-variant-choice e data-full-variant + data-variant-image são ambos válidos. */
    return root || document;
  }

  function syncCardHints(root){
    (root || document).querySelectorAll('[data-product-card]').forEach(function(card){
      const detail = detailForCard(card);
      const hasReal = hasRealVariantChoices(detail);
      let hint = card.querySelector('.mh-variant-hint');
      const title = (card.dataset.title || '').trim();

      if(!hasReal){
        if(hint) hint.remove();
        return;
      }

      if(!hint){
        hint = document.createElement('small');
        hint.className = 'mh-variant-hint';
        const actions = card.querySelector('.mh-card-actions');
        if(actions) card.insertBefore(hint, actions);
        else card.appendChild(hint);
      }

      hint.textContent = REAL_VARIANT_HINTS[title] || 'Ao visualizar, escolha a variação disponível.';
    });
  }

  function syncAddButton(detail, label, img){
    const add = detail.querySelector('[data-demo-add]');
    if(!add) return;
    const base = add.dataset.baseTitle || (detail.querySelector('h4')?.textContent || add.dataset.demoTitle || 'Produto');
    add.dataset.baseTitle = base;
    add.dataset.demoTitle = label ? (base + ' — ' + label) : base;
    if(img) add.dataset.demoImage = img;
  }

  function applyRealVariant(btn, makeSelectedVisible){
    if(!btn) return;
    const detail = btn.closest('[data-product-detail]');
    if(!detail) return;

    const label = btn.dataset.variantLabel || btn.textContent.trim();
    const img = btn.dataset.variantImage || '';

    detail.querySelectorAll('[data-variant-choice]').forEach(function(choice){
      choice.classList.toggle('is-active', choice === btn);
    });

    const selected = detail.querySelector('[data-variant-selected]');
    if(selected){
      selected.textContent = 'Selecionado: ' + label;
      if(makeSelectedVisible) selected.hidden = false;
    }

    if(img){
      const slides = Array.from(detail.querySelectorAll('[data-gallery-slide]'));
      slides.forEach(function(slide, index){
        slide.src = img;
        slide.alt = label;
        slide.hidden = index !== 0;
        slide.classList.toggle('is-active', index === 0);
      });
      const gallery = detail.querySelector('[data-product-gallery]');
      if(gallery) gallery.dataset.galleryIndex = '0';
      detail.querySelectorAll('[data-gallery-dot]').forEach(function(dot, index){
        dot.classList.toggle('is-active', index === 0);
        dot.hidden = index > 0;
      });
      detail.querySelectorAll('[data-gallery-prev],[data-gallery-next]').forEach(function(el){
        el.style.display = 'none';
      });
    }

    syncAddButton(detail, label, img);
  }

  function prepareRealVariants(root){
    (root || document).querySelectorAll('[data-product-detail]').forEach(function(detail){
      if(!hasRealVariantChoices(detail)) return;

      detail.dataset.variantReady = 'real';
      const selected = detail.querySelector('[data-variant-selected]');
      if(selected && /nenhuma varia/i.test(selected.textContent || '')){
        selected.textContent = 'Escolha uma variação.';
      }

      const first = detail.querySelector('[data-variant-choice]');
      if(first && !detail.dataset.realVariantInitialized){
        detail.dataset.realVariantInitialized = '1';
        applyRealVariant(first, false);
      }
    });
  }

  window.mhSetupVariantPickers = function(root){
    removeLegacyVariantUI(root || document);
    prepareRealVariants(root || document);
    syncCardHints(root || document);
  };

  document.addEventListener('click', function(e){
    const variantBtn = e.target.closest('[data-variant-choice]');
    if(variantBtn){
      e.preventDefault();
      applyRealVariant(variantBtn, true);
      return;
    }

    if(e.target.closest('[data-category-open],[data-product-open],[data-favorite-jump],[data-sub-open],[data-sub-back]')){
      setTimeout(function(){
        window.mhSetupVariantPickers(document);
      }, 60);
    }
  }, true);

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      window.mhSetupVariantPickers(document);
    }, {once:true});
  } else {
    window.mhSetupVariantPickers(document);
  }
})();


/* V84 — fotos reais das variantes para D4, Rapidinha, Lubi Plus e Linha Phero */
(function(){
  function setVariantPhoto(detail, btn){
    if(!detail || !btn) return;
    const gallery = detail.querySelector('[data-product-gallery]');
    if(!gallery) return;
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const variantImage = btn.dataset.variantImage;
    const ambientImage = detail.dataset.ambientImage || variantImage;
    if(slides[0] && variantImage) slides[0].src = variantImage;
    if(slides[1]) slides[1].src = ambientImage;
    if(slides[2] && variantImage) slides[2].src = variantImage;
    slides.forEach(function(img,i){ img.hidden = i !== 0; img.classList.remove('is-variant-close'); });
    gallery.dataset.galleryIndex = '0';
    gallery.querySelectorAll('[data-gallery-dot]').forEach(function(dot,i){ dot.classList.toggle('is-active', i===0); });
    const add = detail.querySelector('[data-demo-add]');
    if(add){
      const base = add.dataset.baseTitle || (detail.querySelector('h4') && detail.querySelector('h4').textContent) || 'Produto';
      add.dataset.baseTitle = base;
      add.dataset.demoTitle = base + ' — ' + (btn.dataset.fullVariant || btn.textContent.trim());
      add.dataset.demoImage = variantImage || add.dataset.demoImage || '';
    }
  }
  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-full-variant][data-variant-image]');
    if(!btn) return;
    const detail = btn.closest('[data-product-detail]');
    if(!detail) return;
    detail.querySelectorAll('[data-full-variant]').forEach(function(b){ b.classList.toggle('is-active', b===btn); });
    setVariantPhoto(detail, btn);
  });
  function initVariantPhotos(scope){
    (scope||document).querySelectorAll('[data-product-detail][data-ambient-image]').forEach(function(detail){
      const active = detail.querySelector('[data-full-variant].is-active') || detail.querySelector('[data-full-variant][data-variant-image]');
      if(active) setVariantPhoto(detail, active);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initVariantPhotos(document); });
  else initVariantPhotos(document);
})();


/* V104 — preços calculados pelo custo do catálogo + 40% */
window.MIHMOSA_CATALOG_PRICE_MAP={"p04":{"Gel 15g - Ref. 4800":"R$ 28,90"},"p05":{"Gel 15g - Ref. 4500":"R$ 29,90","Cápsulas 3un | 2g cada - Ref. 8810":"R$ 17,90"},"p06":{"Gel 15g":"R$ 26,90","Pomada 7,5g":"R$ 25,90","Cápsulas 3 un.":"R$ 17,90"},"p07":{"Gel 15g":"R$ 34,90","Cápsulas 3 un.":"R$ 22,90","Sachê 5g":"R$ 14,90"},"p08":{"Gel 15g":"R$ 26,90","Pomada 7,5g":"R$ 25,90","Cápsulas 3 un.":"R$ 17,90"},"p09":{"Gel 15g":"R$ 26,90","Cápsulas 3 un.":"R$ 17,90"},"p10":{"Gel 15g":"R$ 26,90","Cápsulas 3 un.":"R$ 17,90"},"p11":{"Gel 15g":"R$ 26,90","Pomada 7,5g":"R$ 25,90","Cápsulas 3 un.":"R$ 17,90"},"p12":{"Gel 15g":"R$ 26,90","Pomada 7,5g":"R$ 25,90","Cápsulas 3 un.":"R$ 17,90"},"p13":{"Gel 15g":"R$ 26,90","Cápsulas 3 un.":"R$ 17,90"},"p14":{"Gel 15g":"R$ 29,90"},"p15":{"Gel 15g":"R$ 26,90","Pomada 7,5g":"R$ 25,90","Cápsulas 3 un.":"R$ 17,90"},"p16":{"Gel 15g":"R$ 26,90"},"p17":{"Gel 15g":"R$ 26,90","Cápsulas 3 un.":"R$ 17,90"},"p18":{"Gel 15g":"R$ 26,90","Cápsulas 3 un.":"R$ 17,90","Morango · Spray 15ml":"R$ 38,90","Menta · Spray 15ml":"R$ 38,90","Chiclete · Spray 15ml":"R$ 38,90"},"p19":{"Chiclete":"R$ 32,90","Menta":"R$ 32,90","Morango":"R$ 32,90"},"p20":{"Eletrizante":"R$ 33,90","Esquenta e Esfria":"R$ 33,90","Mix Intenso":"R$ 33,90"},"p21":{"Morango Ice":"R$ 38,90","Mentho-Lyptus Extra Forte":"R$ 38,90","Chiclete Ice":"R$ 38,90"},"p22":{"Eletrizante":"R$ 33,90","Extra Ice":"R$ 33,90","Extra Hot":"R$ 33,90"},"p24":{"Algodão Doce":"R$ 29,90","Chiclete de Hortelã":"R$ 29,90","Chiclete Intenso":"R$ 29,90","Morango c/Framboesa":"R$ 29,90","Uva Verde":"R$ 29,90","Morango c/ Framboesa":"R$ 29,90"},"p25":{"Morango Hot":"R$ 14,90","Chiclete Hot":"R$ 14,90","Morango c/Chocolate Hot":"R$ 14,90","Cereja Ice":"R$ 14,90","Ice Menta":"R$ 14,90","Caipirinha Ice":"R$ 14,90","Morango · Hot":"R$ 14,90","Chiclete · Hot":"R$ 14,90","Morango c/ Chocolate · Hot":"R$ 14,90","Cereja · Ice":"R$ 14,90","Ice Menta · Ice":"R$ 14,90","Caipirinha · Ice":"R$ 14,90"},"p26":{"Vodka c/ Melancia":"R$ 14,90","Vinho Tinto":"R$ 14,90","Caipirinha":"R$ 14,90"},"p27":{"Hot Beijável":"R$ 35,90","Morango Cereja":"R$ 35,90","Neutro":"R$ 35,90","Beijável Morango":"R$ 35,90","Frozen Beijável":"R$ 35,90"},"p28":{"Ácido Hialurônico · 60g":"R$ 35,90"},"p29":{"Maçã Verde":"R$ 37,90","Abacaxi":"R$ 37,90","Chiclete de Hortelã":"R$ 37,90"},"p30":{"Morango Hot 30g":"R$ 22,90","Sabores Sortidos 30g":"R$ 22,90","Neutro 30g":"R$ 22,90","Chapéu de Limão 30g":"R$ 22,90","Tutti Frutti 30g":"R$ 22,90","Morango Hot Power 60g":"R$ 22,90"},"p32":{"Perfume em Spray 30ml":"R$ 30,90","Body Splash 120ml":"R$ 50,90","Óleo de Massagem 120ml":"R$ 46,90","Desodorante Íntimo 200ml":"R$ 50,90","Hidratante Corporal 200ml":"R$ 52,90","Óleo Atrativo 10ml":"R$ 30,90","Desodorante Íntimo 100ml":"R$ 25,90"},"p33":{"Atrevida":"R$ 27,90","Audaciosa":"R$ 27,90","Selvagem":"R$ 27,90"},"p34":{"Morango":"R$ 31,90","Chiclete":"R$ 31,90","Ice Menta":"R$ 31,90"},"p35":{"Chiclete":"R$ 22,90","Morango":"R$ 22,90"},"p36":{"Morango":"R$ 29,90","Menta":"R$ 29,90","Chiclete":"R$ 29,90"},"p37":{"Morango":"R$ 36,90","Chiclete":"R$ 36,90","Chocolate":"R$ 36,90"},"p38":{"Provoque":"R$ 45,90","Seduza":"R$ 45,90","Instigue":"R$ 45,90","Envolva":"R$ 45,90","Cative":"R$ 45,90"},"p39":{"Chiclete 200g":"R$ 57,90","Chiclete de Uva 200g":"R$ 57,90","Morango c/ Chantilly 200g":"R$ 57,90","Chiclete":"R$ 57,90","Chiclete de Uva":"R$ 57,90","Morango c/ Chantilly":"R$ 57,90"},"p40":{"Morango":"R$ 50,90","Erva-doce":"R$ 50,90","Menta":"R$ 50,90","Chiclete":"R$ 50,90","Bala de Goma":"R$ 50,90","Chiclete de Hortelã":"R$ 50,90"},"p41":{"Morango 60g":"R$ 23,90","Chiclete 60g":"R$ 23,90","Morango":"R$ 23,90","Chiclete":"R$ 23,90"},"p42":{"Bala de Goma 120ml":"R$ 31,90","Chiclete 120ml":"R$ 31,90","Morango 120ml":"R$ 31,90","Bala de Goma":"R$ 31,90","Chiclete":"R$ 31,90","Morango":"R$ 31,90"},"p43":{"Bala de Goma 250g":"R$ 68,90","Chiclete 250g":"R$ 68,90","Morango 250g":"R$ 68,90","Bala de Goma":"R$ 68,90","Chiclete":"R$ 68,90","Morango":"R$ 68,90"},"p46":{"Feminino 5g - Ref. 6055":"R$ 12,90","Masculino 5g - Ref. 6056":"R$ 12,90","Feminino":"R$ 12,90","Masculino":"R$ 12,90"},"p48":{"Tesão de Touro 10ml":"R$ 11,90","Tesão de Vaca 10ml":"R$ 11,90","Tesão Energético 10ml":"R$ 11,90","Tesão de Jegue 10ml":"R$ 11,90","Tesão de Égua 10ml":"R$ 11,90","Tesão Energético Maçã Verde 10ml":"R$ 11,90","Masculino · Touro":"R$ 11,90","Feminino · Vaca":"R$ 11,90","Unissex · Energético":"R$ 11,90","Masculino · Jegue":"R$ 11,90","Feminino · Égua":"R$ 11,90","Unissex · Energético Maçã Verde":"R$ 11,90"},"p49":{"Caramelo Salgado 10g":"R$ 11,90","Chocolate 10g":"R$ 11,90","Caramelo Salgado":"R$ 11,90","Chocolate":"R$ 11,90"},"p51":{"Morango":"R$ 52,90","Chocolate":"R$ 52,90","Chiclete":"R$ 52,90"},"p52":{"Morango 25g - Ref. 70000":"R$ 17,90","Chocolate 25g - Ref. 70010":"R$ 17,90","Menta 25g - Ref. 70020":"R$ 17,90","Morango":"R$ 17,90","Chocolate":"R$ 17,90","Menta":"R$ 17,90"}};
(function(){
  function mappedPrice(detail,btn){
    if(!detail||!btn)return '';
    var pid=detail.dataset.productDetail||'';
    var label=btn.dataset.fullVariant||btn.dataset.variantLabel||btn.textContent.trim();
    return ((window.MIHMOSA_CATALOG_PRICE_MAP[pid]||{})[label])||btn.dataset.variantPrice||'';
  }
  function sync(detail,btn){
    var price=mappedPrice(detail,btn);
    if(!price)return;
    btn.dataset.variantPrice=price;
    var visible=detail.querySelector('.mh-detail-copy > b');
    if(visible)visible.textContent=price;
    var add=detail.querySelector('[data-demo-add]');
    if(add)add.dataset.demoPrice=price;
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-full-variant],[data-variant-choice]');
    if(!btn)return;
    var detail=btn.closest('[data-product-detail]');
    if(detail) setTimeout(function(){sync(detail,btn)},0);
  });
  function prime(root){
    (root||document).querySelectorAll('[data-product-detail]').forEach(function(detail){
      var pid=detail.dataset.productDetail||''; var map=window.MIHMOSA_CATALOG_PRICE_MAP[pid]||{};
      detail.querySelectorAll('[data-full-variant],[data-variant-choice]').forEach(function(btn){
        var label=btn.dataset.fullVariant||btn.dataset.variantLabel||btn.textContent.trim();
        if(map[label])btn.dataset.variantPrice=map[label];
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){prime(document)},{once:true});else prime(document);
  new MutationObserver(function(){prime(document)}).observe(document.documentElement,{childList:true,subtree:true});
})();

/* V115 — Goze+ card variant image/price interaction */
(function(){
  function syncGozeCardVariant(btn){
    if(!btn) return;
    var card = btn.closest('[data-product-card]');
    if(!card || card.dataset.title !== 'Goze+') return;

    card.querySelectorAll('[data-goze-card-variant]').forEach(function(b){
      b.classList.toggle('is-active', b === btn);
    });

    var img = card.querySelector('.mh-catalog-media img');
    if(img && btn.dataset.variantImage){
      img.src = btn.dataset.variantImage;
      img.alt = 'Goze+ — ' + (btn.dataset.fullVariant || btn.textContent.trim());
    }

    card.dataset.gozeSelectedVariant = btn.dataset.fullVariant || '';
    card.dataset.gozeSelectedImage = btn.dataset.variantImage || '';
    card.dataset.gozeSelectedPrice = btn.dataset.variantPrice || '';

    var cart = card.querySelector('[data-demo-add]');
    if(cart){
      cart.dataset.demoTitle = 'Goze+ — ' + (btn.dataset.fullVariant || btn.textContent.trim());
      cart.dataset.demoPrice = btn.dataset.variantPrice || cart.dataset.demoPrice || '';
      cart.dataset.demoImage = btn.dataset.variantImage || cart.dataset.demoImage || '';
    }
  }

  document.addEventListener('click', function(e){
    var variantBtn = e.target.closest('[data-goze-card-variant]');
    if(variantBtn){
      e.preventDefault();
      e.stopPropagation();
      syncGozeCardVariant(variantBtn);
      return;
    }

    var openBtn = e.target.closest('[data-product-open="p05"]');
    if(!openBtn) return;
    var card = openBtn.closest('[data-product-card]');
    if(!card) return;

    var selected = card.querySelector('[data-goze-card-variant].is-active');
    if(!selected) return;

    setTimeout(function(){
      var scope = card.closest('#mh-category-display') || document;
      var detail = scope.querySelector('[data-product-detail="p05"]');
      if(!detail) return;
      var full = selected.dataset.fullVariant || '';
      var target = Array.from(detail.querySelectorAll('[data-full-variant]')).find(function(b){
        return (b.dataset.fullVariant || '') === full;
      });
      if(target) target.click();
    }, 0);
  });

  function prime(root){
    (root || document).querySelectorAll('[data-product-card][data-title="Goze+"]').forEach(function(card){
      var first = card.querySelector('[data-goze-card-variant].is-active') || card.querySelector('[data-goze-card-variant]');
      if(first) syncGozeCardVariant(first);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ prime(document); }, {once:true});
  } else {
    prime(document);
  }

  new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      m.addedNodes.forEach(function(node){
        if(node.nodeType === 1) prime(node);
      });
    });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();


// V160 — confirmação de maioridade persistente para não reaparecer ao navegar/ir ao checkout
(() => {
  const AGE_KEY = 'mihmosa-age-confirmed-v1';
  const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 dias

  const hasValidConfirmation = () => {
    try {
      const value = Number(localStorage.getItem(AGE_KEY) || 0);
      return value > 0 && (Date.now() - value) < MAX_AGE_MS;
    } catch (_) {
      return false;
    }
  };

  const saveConfirmation = () => {
    try { localStorage.setItem(AGE_KEY, String(Date.now())); } catch (_) {}
  };

  const initAgeGate = () => {
    const gate = document.querySelector('[data-age-gate]');
    if (!gate) return;

    const yes = gate.querySelector('[data-age-yes]');
    const no = gate.querySelector('[data-age-no]');
    const back = gate.querySelector('[data-age-back]');
    const actions = gate.querySelector('[data-age-actions]');
    const denied = gate.querySelector('[data-age-denied]');

    if (hasValidConfirmation()) {
      gate.hidden = true;
      document.body.classList.remove('mh-age-locked');
      return;
    }

    gate.hidden = false;
    document.body.classList.add('mh-age-locked');
    if (actions) actions.hidden = false;
    if (denied) denied.hidden = true;

    yes?.addEventListener('click', () => {
      saveConfirmation();
      gate.hidden = true;
      document.body.classList.remove('mh-age-locked');
    });

    no?.addEventListener('click', () => {
      if (actions) actions.hidden = true;
      if (denied) denied.hidden = false;
    });

    back?.addEventListener('click', () => {
      if (denied) denied.hidden = true;
      if (actions) actions.hidden = false;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeGate, { once: true });
  } else {
    initAgeGate();
  }
})();


// V144 — selos de disponibilidade editáveis, sem inventar estoque
(() => {
  const labels = {
    ready: ['Pronta entrega', 'is-ready'],
    order: ['Sob encomenda', 'is-order'],
  };
  const applyAvailability = () => {
    document.querySelectorAll('[data-product-card]').forEach((card) => {
      const state = (card.dataset.availability || 'neutral').toLowerCase();
      const cfg = labels[state];

      if (!cfg) {
        /* Cards without a state keep any server-rendered availability. */
        return;
      }

      if (card.querySelector('.mh-availability-badge')) return;
      const badge = document.createElement('span');
      badge.className = `mh-availability-badge ${cfg[1]}`;
      badge.textContent = cfg[0];
      const meta = card.querySelector('.mh-card-meta');
      const price = card.querySelector('.mh-price');
      if (meta) meta.insertAdjacentElement('afterend', badge);
      else if (price) price.insertAdjacentElement('afterend', badge);
      else card.appendChild(badge);
    });
  };
  const startAvailability = () => {
    applyAvailability();
    const target = document.querySelector('#mh-category-display') || document.body;
    const observer = new MutationObserver(() => applyAvailability());
    observer.observe(target, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAvailability, { once: true });
  } else {
    startAvailability();
  }
})();


/* V161 — catálogo visual conectado a produtos/variantes REAIS da Shopify.
   Mantém o design existente e intercepta apenas os botões que antes usavam o carrinho ilustrativo. */
(function(){
  'use strict';
  const PID_HANDLE = {"p03":"suga","p04":"ardilosa","p05":"goze","p24":"yummy-gourmet-1","p25":"bolinha-hot-1","p26":"yummy-drinks-1","p27":"d4-gel-umectante-1","p28":"d4-acido-hialuronico-1","p29":"d4-textura-leitosa-1","p30":"rapidinha-1","p31":"lubi-plus-1","p32":"linha-phero-1","p33":"felina","p34":"um-beijo-e-um-cheiro","p35":"perfume-de-calcinha","p36":"fogo-da-paixao","p37":"corpo-a-corpo","p38":"excitantric","p39":"blendy","p40":"poesie-desodorante-intimo","p41":"poesie-sabonete-intimo","p42":"poesie-body-splash","p43":"poesie-esfoliante","p44":"higienizador-de-brinquedos","p45":"cybertalco","p46":"exotic-honey","p47":"gotas-da-paixao","p48":"tesao","p49":"pacoca","p50":"fantasias-comestiveis","p51":"yummy-calcinha-comestivel","p52":"canetas-sweet-body","p53":"proteses-sexy-fantasy","p54":"macicos-aromaticos","p55":"proteses-com-vibrador","p56":"proteses-com-escroto-e-ventosa","p57":"ultra-realisticos","p58":"capas-expansoras","p59":"plugs-com-pedra","p60":"plugs-especiais","p72":"macico","p73":"com-vibro","p74":"macico-aromatico","p75":"com-vibro-aromatico","p76":"petalas-aromaticas","p77":"baralho-kama-sexy","p78":"cones-para-pompoarismo","p79":"pompoar-com-vibro","p80":"plugs-metalizados","p81":"lite-plug","p82":"caudas-e-algemas","p83":"capas-sensoriais","p66":"dados-e-jogos","p67":"chibatas-palmatorias-e-chicotes","p68":"vendas-e-cordas","p69":"algemas-e-amarras","p70":"linha-submission","p71":"kits-sado"};
  const TITLE_HANDLE = {"Suga+ — Gel Sugador Líquido Beijável 20g":"suga","Ardilosa":"ardilosa","Goze+":"goze","Yummy Gourmet":"yummy-gourmet-1","Bolinha Hot":"bolinha-hot-1","Yummy Drinks":"yummy-drinks-1","D4 Gel Umectante":"d4-gel-umectante-1","D4 Ácido Hialurônico":"d4-acido-hialuronico-1","D4 Textura Leitosa":"d4-textura-leitosa-1","Rapidinha":"rapidinha-1","Lubi Plus":"lubi-plus-1","Linha Phero":"linha-phero-1","Felina":"felina","Um Beijo e Um Cheiro":"um-beijo-e-um-cheiro","Perfume de Calcinha":"perfume-de-calcinha","Fogo da Paixão":"fogo-da-paixao","Corpo a Corpo":"corpo-a-corpo","Excitantric":"excitantric","Blendy":"blendy","Poésie Desodorante Íntimo":"poesie-desodorante-intimo","Poésie Sabonete Íntimo":"poesie-sabonete-intimo","Poésie Body Splash":"poesie-body-splash","Poésie Esfoliante":"poesie-esfoliante","Higienizador de Brinquedos":"higienizador-de-brinquedos","Cybertalco":"cybertalco","Exotic Honey":"exotic-honey","Gotas da Paixão":"gotas-da-paixao","Tesão":"tesao","Paçoca":"pacoca","Fantasias Comestíveis":"fantasias-comestiveis","Yummy — Calcinha Comestível":"yummy-calcinha-comestivel","Canetas Sweet Body":"canetas-sweet-body","Próteses Sexy Fantasy":"proteses-sexy-fantasy","Maciços Aromáticos":"macicos-aromaticos","Próteses com Vibrador":"proteses-com-vibrador","Próteses com Escroto e Ventosa":"proteses-com-escroto-e-ventosa","Ultra Realísticos":"ultra-realisticos","Capas Expansoras":"capas-expansoras","Plugs com Pedra":"plugs-com-pedra","Plugs Especiais":"plugs-especiais","Maciço":"macico","Com Vibro":"com-vibro","Maciço Aromático":"macico-aromatico","Com Vibro Aromático":"com-vibro-aromatico","Pétalas Aromáticas":"petalas-aromaticas","Baralho Kama Sexy":"baralho-kama-sexy","Cones para Pompoarismo":"cones-para-pompoarismo","Pompoar com Vibro":"pompoar-com-vibro","Plugs Metalizados":"plugs-metalizados","Lite Plug":"lite-plug","Caudas e Algemas":"caudas-e-algemas","Capas Sensoriais":"capas-sensoriais","Dados e Jogos":"dados-e-jogos","Chibatas, Palmatórias e Chicotes":"chibatas-palmatorias-e-chicotes","Vendas e Cordas":"vendas-e-cordas","Algemas e Amarras":"algemas-e-amarras","Linha Submission":"linha-submission","Kits Sado":"kits-sado","Yummy – Gel Térmico Beijável 15 ml":"yummy-gel-termico-beijavel-15-ml-1"};
  const productCache = new Map();

  // O carrinho ilustrativo antigo não deve mais participar do total nem bloquear o checkout.
  try { localStorage.removeItem('mihmosa-demo-cart-v1'); } catch (_) {}

  function normalize(s){
    return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\s+/g,' ').trim();
  }
  function refFromText(s){
    const m=String(s||'').match(/(?:ref\.?\s*[:.-]?\s*)([a-z0-9]+)\b/i);
    return m ? m[1] : '';
  }
  function getContext(button){
    const yummy=button.closest('[data-yummy-detail]');
    if(yummy){
      const flavor=yummy.querySelector('[data-yummy-flavor].is-active')?.dataset.yummyFlavor || yummy.querySelector('[data-yummy-selected]')?.textContent?.trim() || 'Morango';
      const qty=Math.max(1,Number(yummy.querySelector('[data-yummy-qty]')?.textContent)||1);
      return {handle:'yummy-gel-termico-beijavel-15-ml-1', ref:'', label:flavor, qty};
    }

    const detail=button.closest('[data-product-detail]');
    const card=button.closest('[data-product-card]');
    const pid=detail?.dataset.productDetail || '';
    let title=(detail?.querySelector('.mh-detail-copy h4, h4, h3')?.textContent || card?.dataset.title || button.dataset.baseTitle || button.dataset.demoTitle || '').trim();
    if(title.includes(' — ') && TITLE_HANDLE[title.split(' — ')[0]]) title=title.split(' — ')[0];
    const handle=PID_HANDLE[pid] || TITLE_HANDLE[title] || '';

    let active=detail?.querySelector('[data-full-variant].is-active, [data-variant-choice].is-active');
    if(!active) active=card?.querySelector('[data-goze-card-variant].is-active, [data-full-variant].is-active');
    const ref=(active?.dataset.variantRef || refFromText(active?.dataset.fullVariant) || refFromText(active?.textContent) || refFromText(button.dataset.demoTitle) || '').trim();
    const label=(active?.dataset.fullVariant || active?.dataset.variantLabel || active?.textContent || '').trim();
    const qtyNode=detail?.querySelector('[data-full-qty]');
    const qty=Math.max(1,Number(qtyNode?.textContent)||1);
    return {handle,ref,label,qty};
  }

  async function loadProduct(handle){
    if(!handle) throw new Error('Produto sem vínculo com a Shopify.');
    if(productCache.has(handle)) return productCache.get(handle);
    const p=fetch('/products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}})
      .then(async r=>{ if(!r.ok) throw new Error('Produto não disponível na Loja virtual.'); return r.json(); });
    productCache.set(handle,p);
    try { return await p; } catch(e){ productCache.delete(handle); throw e; }
  }

  function pickVariant(product,ctx){
    const variants=Array.isArray(product?.variants)?product.variants:[];
    if(!variants.length) return null;
    if(ctx.ref){
      const bySku=variants.find(v=>normalize(v.sku)===normalize(ctx.ref));
      if(bySku) return bySku;
    }
    if(ctx.label){
      const nl=normalize(ctx.label);
      const exact=variants.find(v=>normalize(v.title)===nl || normalize(v.option1)===nl);
      if(exact) return exact;
      const partial=variants.find(v=>normalize(v.title).includes(nl) || nl.includes(normalize(v.title)));
      if(partial) return partial;
    }
    return variants[0];
  }

  async function addReal(button){
    const ctx=getContext(button);
    const product=await loadProduct(ctx.handle);
    const variant=pickVariant(product,ctx);
    if(!variant?.id) throw new Error('Não encontrei a variante selecionada na Shopify.');
    const response=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:Number(variant.id),quantity:ctx.qty})
    });
    if(!response.ok){
      let message='Não foi possível adicionar este item ao carrinho.';
      try{ const data=await response.json(); message=data.description||data.message||message; }catch(_){}
      throw new Error(message);
    }
    return response.json();
  }

  document.addEventListener('click',function(e){
    const button=e.target.closest('[data-demo-add], [data-yummy-add-only]');
    if(!button) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if(button.dataset.shopifyAdding==='1') return;
    button.dataset.shopifyAdding='1';
    button.disabled=true;
    const original=button.textContent;
    button.textContent='Adicionando…';
    addReal(button).then(function(){
      button.textContent='✓ Adicionado';
      setTimeout(function(){button.textContent=original},900);
      document.querySelector('[data-cart-toggle]')?.click();
    }).catch(function(err){
      console.error('[MIHMOSA Shopify Cart]',err);
      alert(err?.message || 'Não foi possível adicionar o produto. Tente novamente.');
      button.textContent=original;
    }).finally(function(){
      button.disabled=false;
      delete button.dataset.shopifyAdding;
    });
  },true);
})();
